import { Color, Transform, TilingMirror, ImageResource, ImageFill as ImageFill$1, TilingImageFill, TilingRepeat, CustomGradientFill, dep, Matrix, RawLinearGradientFill, RawRadialGradientFill, RawImageFill, Fill, ColorFill, BlurFilter, LineCap, LineJoin } from '@tencent/alloy-renderer';
import { _ as _slicedToArray, a as _createClass, b as _classCallCheck, c as _regeneratorRuntime, d as _toConsumableArray, e as _inherits, f as _getPrototypeOf, g as _possibleConstructorReturn, h as _get, i as _defineProperty } from './vendor-c51dfba7.esm.js';
import DOMPurify from 'dompurify';
import { BrowserGlBuffer, BrowserCanvas } from '@tencent/alloy-renderer-browser';
import { pointsOnPath } from 'points-on-path';
import { ColorAdjustmentFilter, SharpenFilter, Direction, ShadowFilter as ShadowFilter$1, SoftEdgeFilter as SoftEdgeFilter$1, GlowFilter as GlowFilter$1, ReflectionFilter as ReflectionFilter$1 } from '@tencent/alloy-renderer-tdoc';

/**
 * 图案填充最小重复单元
 */
var patternFillPathMap = {
  pct5: function pct5(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <circle cx=\"6\" cy=\"6\" r=\"1\" fill=\"").concat(fgClr, "\"/>\n        <circle cx=\"14\" cy=\"14\" r=\"1\" fill=\"").concat(fgClr, "\"/></g>");
  },
  pct10: function pct10(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"7\" width=\"13\"/>\n        <circle cx=\"1\" cy=\"3\" r=\"1\" fill=\"").concat(fgClr, "\"/>\n        <circle cx=\"7\" cy=\"1\" r=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  pct20: function pct20(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <rect x=\"2\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  pct25: function pct25(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"4\" width=\"8\"/>\n        <rect x=\"2\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  pct30: function pct30(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  pct40: function pct40(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"2\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"10\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"14\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"0\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"8\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"12\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"2\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"10\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"12\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"14\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"0\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"8\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"12\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"2\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"10\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"14\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"0\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"8\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"12\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"2\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"10\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"14\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"0\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"8\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"12\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct50: function pct50(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"4\" width=\"4\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"2\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct60: function pct60(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"10\" width=\"8\"/>\n        <rect x=\"2\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"4\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"2\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"0\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct70: function pct70(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"4\" width=\"8\"/>\n        <rect x=\"2\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct75: function pct75(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"8\" width=\"8\"/>\n        <rect x=\"2\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n        <rect x=\"6\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct80: function pct80(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"7\" width=\"13\"/>\n        <circle cx=\"1\" cy=\"3\" r=\"1\" fill=\"").concat(bgClr, "\"/>\n        <circle cx=\"7\" cy=\"1\" r=\"1\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  pct90: function pct90(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(fgClr, "\" height=\"8\" width=\"8\"/>\n        <circle cx=\"1\" cy=\"4\" r=\"1\" fill=\"").concat(bgClr, "\"/>\n        <circle cx=\"5\" cy=\"1\" r=\"1\" fill=\"").concat(bgClr, "\"/>\n    </g>");
  },
  ltDnDiag: function ltDnDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"1\" y=\"0\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"3\" y=\"1\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"5\" y=\"3\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"7\" y=\"5\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"9\" y=\"7\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"7\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"1\" y=\"9\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  ltUpDiag: function ltUpDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"7\" y=\"0\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"5\" y=\"1\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"3\" y=\"3\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"1\" y=\"5\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"7\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"9\" y=\"7\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"7\" y=\"9\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dkDnDiag: function dkDnDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"0\" y=\"0\" width=\"4\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"1\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"3\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"5\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"9\" width=\"4\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dkUpDiag: function dkUpDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"6\" y=\"0\" width=\"4\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"1\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"3\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"5\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"9\" width=\"4\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  wdDnDiag: function wdDnDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"1\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"1\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"3\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"3\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"5\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"5\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"7\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"9\" y=\"8\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"8\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"9\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  wdUpDiag: function wdUpDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"10\"/>\n        <rect x=\"8\" y=\"0\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"7\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"1\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"5\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"3\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"3\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"5\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"1\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"7\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"8\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"9\" y=\"8\" width=\"1\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"9\" width=\"2\" height=\"1\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  ltVert: function ltVert(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"5\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"10\" x2=\"5\" y1=\"0\" x1=\"5\" strokeWidth=\"1\"/>\n    </g>");
  },
  ltHorz: function ltHorz(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"5\" width=\"10\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"5\" x2=\"10\" y1=\"5\" x1=\"0\" strokeWidth=\"1\" />\n    </g>");
  },
  narVert: function narVert(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"8\" x2=\"4\" y1=\"0\" x1=\"4\" strokeWidth=\"1\"/>\n    </g>");
  },
  narHorz: function narHorz(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"4\" x2=\"8\" y1=\"4\" x1=\"0\" strokeWidth=\"1\"/>\n    </g>");
  },
  dkVert: function dkVert(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"10\" width=\"5\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"10\" x2=\"0\" y1=\"0\" x1=\"0\" strokeWidth=\"2\"/>\n    </g>");
  },
  dkHorz: function dkHorz(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"5\" width=\"10\"/>\n        <line stroke=\"").concat(fgClr, "\" y2=\"0\" x2=\"10\" y1=\"0\" x1=\"0\" strokeWidth=\"2\"/>\n    </g>");
  },
  dashDnDiag: function dashDnDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"26\" width=\"16\"/>\n        <rect x=\"0\" y=\"16\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"18\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"20\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"22\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dashUpDiag: function dashUpDiag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"26\" width=\"16\"/>\n        <rect x=\"0\" y=\"22\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"20\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"18\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"16\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dashHorz: function dashHorz(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"20\" width=\"10\"/>\n        <rect x=\"0\" y=\"18\" width=\"5\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"5\" y=\"8\" width=\"5\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dashVert: function dashVert(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"20\" width=\"10\"/>\n        <rect x=\"0\" y=\"10\" width=\"2\" height=\"10\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"0\" width=\"2\" height=\"10\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  smConfetti: function smConfetti(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  lgConfetti: function lgConfetti(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"2\" y=\"2\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"12\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"8\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"0\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"4\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"10\" width=\"4\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  zigZag: function zigZag(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"16\"/>\n        <rect x=\"2\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"0\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  wave: function wave(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"6\" width=\"16\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  diagBrick: function diagBrick(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"8\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"6\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  horzBrick: function horzBrick(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"7\" y=\"0\" width=\"2\" height=\"6\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"6\" width=\"16\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"8\" width=\"2\" height=\"6\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"14\" width=\"16\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  weave: function weave(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"0\" width=\"2\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"11\" y=\"0\" width=\"2\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"3\" width=\"1\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"7\" y=\"3\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"15\" y=\"3\" width=\"1\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"5\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"5\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"5\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"7\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"11\" y=\"7\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"11\" width=\"1\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"9\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"9\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"9\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"7\" y=\"11\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"15\" y=\"11\" width=\"1\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"13\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"13\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"13\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"15\" width=\"2\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"11\" y=\"15\" width=\"2\" height=\"1\"/>\n    </g>");
  },
  plaid: function plaid(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"8\" y=\"0\" width=\"8\" height=\"8\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  divot: function divot(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"2\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"14\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"14\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dotGrid: function dotGrid(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  dotDmnd: function dotDmnd(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"0\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"8\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"4\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  shingle: function shingle(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"4\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"2\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"6\" y=\"4\" width=\"2\" height=\"4\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"4\" y=\"8\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"0\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"2\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"10\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"10\" y=\"12\" width=\"2\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"12\" y=\"14\" width=\"4\" height=\"2\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  trellis: function trellis(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect x=\"0\" y=\"0\" width=\"8\" height=\"11\" fill=\"").concat(fgClr, "\"/>\n        <rect x=\"8\" y=\"5\" width=\"8\" height=\"11\" fill=\"").concat(fgClr, "\"/>\n    </g>");
  },
  sphere: function sphere(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"0\" width=\"7\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"0\" width=\"7\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"4\" y=\"1\" width=\"4\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"1\" width=\"1\" height=\"7\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"8\" y=\"1\" width=\"1\" height=\"7\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"3\" width=\"7\" height=\"6\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"9\" width=\"1\" height=\"7\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"8\" y=\"9\" width=\"1\" height=\"7\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"8\" width=\"7\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"12\" y=\"9\" width=\"4\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"11\" width=\"7\" height=\"6\"/>\n    </g>");
  },
  smGrid: function smGrid(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"0\" width=\"8\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"2\" width=\"2\" height=\"6\"/>\n    </g>");
  },
  lgGrid: function lgGrid(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"0\" width=\"16\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"2\" width=\"2\" height=\"14\"/>\n    </g>");
  },
  smCheck: function smCheck(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"8\" width=\"8\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"0\" width=\"4\" height=\"4\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"4\" y=\"4\" width=\"4\" height=\"4\"/>\n    </g>");
  },
  lgCheck: function lgCheck(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"0\" width=\"8\" height=\"8\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"8\" y=\"8\" width=\"8\" height=\"8\"/>\n    </g>");
  },
  openDmnd: function openDmnd(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"0\" width=\"1\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"15\" y=\"0\" width=\"1\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"0\" y=\"15\" width=\"1\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"15\" y=\"15\" width=\"1\" height=\"1\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"3\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"5\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"7\" y=\"7\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"5\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"11\" y=\"3\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"9\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"11\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"13\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"9\" y=\"9\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"11\" y=\"11\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"13\" y=\"13\" width=\"2\" height=\"2\"/>\n    </g>");
  },
  solidDmnd: function solidDmnd(fgClr, bgClr, scaleW, scaleH) {
    return "<g transform=\"scale(".concat(1 / scaleW, ", ").concat(1 / scaleH, ")\">\n        <rect fill=\"").concat(bgClr, "\" height=\"16\" width=\"16\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"7\" y=\"1\" width=\"2\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"3\" width=\"6\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"5\" width=\"10\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"1\" y=\"7\" width=\"14\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"3\" y=\"9\" width=\"10\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"5\" y=\"11\" width=\"6\" height=\"2\"/>\n        <rect fill=\"").concat(fgClr, "\" x=\"7\" y=\"13\" width=\"2\" height=\"2\"/>\n    </g>");
  }
};
/**
 * 根据preset获取最小重复单元svg
 * @param preset preset
 * @param fgClr 前景色
 * @param bgClr 背景色
 * @param scaleW
 * @param scaleH
 */
function getPatternFillPathFromPrst(preset, fgClr, bgClr, scaleW, scaleH) {
  if (patternFillPathMap[preset]) {
    return patternFillPathMap[preset](fgClr === null || fgClr === void 0 ? void 0 : fgClr.rgba, bgClr === null || bgClr === void 0 ? void 0 : bgClr.rgba, scaleW, scaleH);
  }
  return patternFillPathMap.pct5(fgClr === null || fgClr === void 0 ? void 0 : fgClr.rgba, bgClr === null || bgClr === void 0 ? void 0 : bgClr.rgba, scaleW, scaleH); // default
}
function generatePatternSvgString(patternFill, pageScale) {
  var svgElementString = getPatternFillPathFromPrst(patternFill.preset, patternFill.fgColor, patternFill.bgColor, pageScale, pageScale);
  var size = patternFillSingleSizeMap[patternFill.preset];
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" width=\"".concat(size.width / pageScale, "\" height=\"").concat(size.height / pageScale, "\">").concat(svgElementString, "</svg>");
}
/**
 * 图案填充最小重复单元尺寸
 */
var patternFillSingleSizeMap = {
  pct5: {
    height: 16,
    width: 16
  },
  pct10: {
    height: 7,
    width: 13
  },
  pct20: {
    height: 8,
    width: 8
  },
  pct25: {
    height: 4,
    width: 8
  },
  pct30: {
    height: 8,
    width: 8
  },
  pct40: {
    height: 16,
    width: 16
  },
  pct50: {
    height: 4,
    width: 4
  },
  pct60: {
    height: 10,
    width: 8
  },
  pct70: {
    height: 4,
    width: 8
  },
  pct75: {
    height: 8,
    width: 8
  },
  pct80: {
    height: 7,
    width: 13
  },
  pct90: {
    height: 8,
    width: 8
  },
  ltDnDiag: {
    height: 10,
    width: 10
  },
  ltUpDiag: {
    height: 10,
    width: 10
  },
  dkDnDiag: {
    height: 10,
    width: 10
  },
  dkUpDiag: {
    height: 10,
    width: 10
  },
  wdDnDiag: {
    height: 10,
    width: 10
  },
  wdUpDiag: {
    height: 10,
    width: 10
  },
  ltVert: {
    height: 10,
    width: 5
  },
  ltHorz: {
    height: 5,
    width: 10
  },
  narVert: {
    height: 8,
    width: 8
  },
  narHorz: {
    height: 8,
    width: 8
  },
  dkVert: {
    height: 10,
    width: 5
  },
  dkHorz: {
    height: 5,
    width: 10
  },
  dashDnDiag: {
    height: 26,
    width: 16
  },
  dashUpDiag: {
    height: 26,
    width: 16
  },
  dashHorz: {
    height: 20,
    width: 10
  },
  dashVert: {
    height: 20,
    width: 10
  },
  smConfetti: {
    height: 16,
    width: 16
  },
  lgConfetti: {
    height: 16,
    width: 16
  },
  zigZag: {
    height: 8,
    width: 16
  },
  wave: {
    height: 6,
    width: 16
  },
  diagBrick: {
    height: 16,
    width: 16
  },
  horzBrick: {
    height: 16,
    width: 16
  },
  weave: {
    height: 16,
    width: 16
  },
  plaid: {
    height: 16,
    width: 16
  },
  divot: {
    height: 16,
    width: 16
  },
  dotGrid: {
    height: 16,
    width: 16
  },
  dotDmnd: {
    height: 16,
    width: 16
  },
  shingle: {
    height: 16,
    width: 16
  },
  trellis: {
    height: 16,
    width: 16
  },
  sphere: {
    height: 16,
    width: 16
  },
  smGrid: {
    height: 8,
    width: 8
  },
  lgGrid: {
    height: 16,
    width: 16
  },
  smCheck: {
    height: 8,
    width: 8
  },
  lgCheck: {
    height: 16,
    width: 16
  },
  openDmnd: {
    height: 16,
    width: 16
  },
  solidDmnd: {
    height: 16,
    width: 16
  }
};

/**
 * 填充模式
 */
var FillMode;
(function (FillMode) {
  /**
   * 透明
   */
  FillMode["NONE"] = "none";
  /**
   * 默认
   */
  FillMode["NORMAL"] = "normal";
  /**
   * 亮
   */
  FillMode["BRIGHT"] = "lightenLess";
  /**
   * 更亮
   */
  FillMode["BRIGHTER"] = "lighten";
  /**
   * 暗
   */
  FillMode["DARK"] = "darkenLess";
  /**
   * 更暗
   */
  FillMode["DARKER"] = "darken";
})(FillMode || (FillMode = {}));

var COLOR_LEV1 = 0.193;
var COLOR_LEV2 = 0.398;
/**
 * 根据 fillMode 生成新的填充颜色
 * @param orgColor
 * @param fillMode
 */
function generateColorWithFillMode(orgColor, fillMode) {
  var color = orgColor;
  switch (fillMode) {
    case FillMode.NONE:
      color = '#ffffff00'; // 背景透明
      break;
    case FillMode.NORMAL:
      break;
    case FillMode.BRIGHT:
      color = gradientColorExtendsAlpha(orgColor, 'rgb(255,255,255)', COLOR_LEV1);
      break;
    case FillMode.BRIGHTER:
      color = gradientColorExtendsAlpha(orgColor, 'rgb(255,255,255)', COLOR_LEV2);
      break;
    case FillMode.DARK:
      color = gradientColorExtendsAlpha(orgColor, 'rgb(0,0,0)', COLOR_LEV1);
      break;
    case FillMode.DARKER:
      color = gradientColorExtendsAlpha(orgColor, 'rgb(0,0,0)', COLOR_LEV2);
      break;
  }
  return color;
}
function gradientColorExtendsAlpha(startColor, endColor, fraction) {
  var colorArray = getColorRGB(startColor);
  var redStart = colorArray[0];
  var greenStart = colorArray[1];
  var blueStart = colorArray[2];
  var alphaStart = colorArray[3];
  colorArray = getColorRGB(endColor);
  var redEnd = colorArray[0];
  var greenEnd = colorArray[1];
  var blueEnd = colorArray[2];
  var redDifference = redEnd - redStart;
  var greenDifference = greenEnd - greenStart;
  var blueDifference = blueEnd - blueStart;
  var redCurrent = Math.round(redStart + fraction * redDifference);
  var greenCurrent = Math.round(greenStart + fraction * greenDifference);
  var blueCurrent = Math.round(blueStart + fraction * blueDifference);
  var alphaCurrent = alphaStart;
  return "rgb(".concat(redCurrent, ",").concat(greenCurrent, ",").concat(blueCurrent, ",").concat(alphaCurrent, ")");
}
/**
 * 转换颜色RGB值，返回一个数组
 * @param color
 */
function getColorRGB(color) {
  var transColor = colorRgb(color);
  if (transColor === color) {
    // 转换失败，继续转换
    if (color.startsWith('rgb')) {
      var index = color.indexOf('(') + 1;
      transColor = color.substring(index, color.length - 1).split(',');
      transColor = transColor.map(function (item) {
        return Number(item);
      });
      if (transColor.length === 3) {
        transColor.push(1);
      }
    }
  }
  return transColor;
}
/**
 * 将UI上的透明度百分比转换成图形、图片等可以接受的alpha通道，单位不是emu
 * @param {number} opacity UI上显示的透明度百分比
 */
var opacityToAlpha = function opacityToAlpha(opacity) {
  return 1 - opacity / 100;
};
function hexToRgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/;
  if (!(reg === null || reg === void 0 ? void 0 : reg.test(hex))) {
    return '';
  }
  var _hex$match$map = hex.match(/\w\w/g).map(function (x) {
      return parseInt(x, 16);
    }),
    _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
    r = _hex$match$map2[0],
    g = _hex$match$map2[1],
    b = _hex$match$map2[2];
  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
}
function getRenderColor(color) {
  if (color === 'none' || !color) {
    return null;
  }
  var colorObj = color2HexAndAlpha(color);
  return Color.fromHex("#".concat(colorObj.colorValue), colorObj.alpha);
}
/**
 * 16进制或rgb的颜色转成 {colorValue :'20ffff' , alpha : 1 }形式
 *
 * @param color  16进制或rgb的颜色
 * @returns {colorValue :'20ffff' , alpha : 0.8}类型
 */
function color2HexAndAlpha(color) {
  if (!color) {
    return {
      colorValue: color,
      alpha: 1
    };
  }
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/;
  // 如果是16进制颜色
  if (reg.test(color)) {
    if (color.length === 4) {
      var sColorNew = '#';
      for (var i = 1; i < 4; i += 1) {
        sColorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      return {
        colorValue: sColorNew,
        alpha: 1
      };
    }
    if (color.length === 7) {
      return {
        colorValue: color.substring(1, 7),
        alpha: 1
      };
    }
    if (color.length === 9) {
      var alpha = parseInt(color.substring(7, 9), 16) / 255;
      return {
        colorValue: color.substring(1, 7),
        alpha: alpha
      };
    }
  } else if (color.toLowerCase().startsWith('rgb')) {
    var index = color.indexOf('(') + 1;
    var transColor = color.substring(index, color.length - 1).split(',');
    if (transColor.length >= 3) {
      return getColorValueAndAlpha(transColor);
    }
  }
  return {
    colorValue: color,
    alpha: 1
  };
}
function getColorValueAndAlpha(transColor) {
  var colorValue = '';
  var alpha = 1;
  for (var i = 0; i < transColor.length; i++) {
    if (i === 3) {
      alpha = parseFloat(transColor[i]);
    } else {
      var trans = parseInt(transColor[i], 10).toString(16);
      trans = trans.length === 1 ? "0".concat(trans) : trans;
      colorValue += trans;
    }
  }
  return {
    colorValue: colorValue,
    alpha: alpha
  };
}
// 颜色16进制转RGBA方法
function colorRgb(colorHex) {
  var sColor = colorHex.toLowerCase();
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/;
  // 如果是16进制颜色
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#';
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
      }
      sColor = sColorNew;
    }
    // 处理六位的颜色值
    var sColorChange = [];
    for (var _i = 1; _i < sColor.length; _i += 2) {
      var d = sColor.slice(_i, _i + 2);
      sColorChange.push(parseInt("0x".concat(d), 16));
    }
    if (sColorChange.length === 4) {
      sColorChange[3] = sColorChange[3] / 255;
    } else {
      sColorChange.push(1);
    }
    return sColorChange;
  }
  return sColor;
}

var UserAgent = {
  isPC: isPC(),
  isChrome: isChrome(),
  isAndroid: isAndroid(),
  isFirefox: isFirefox(),
  isTencentDocDesktopApp: isTencentDocDesktopApp(),
  isWindows: isWindows(),
  isChromiumEdge: isChromiumEdge(),
  /**
   * 是否是window微信小程序
   */
  isWindowWxMiniProgram: isWxMiniProgram() && isWindows(),
  isQQBrowser: isQQBrowser()
};
/**
 * 是否是 PC
 */
function isPC() {
  var userAgent = window.navigator.userAgent;
  return !/mobile|SymbianOS|iphone|android|iPad/i.test(userAgent);
}
/**
 * 是否是 Chrome 浏览器
 */
function isChrome() {
  var userAgent = window.navigator.userAgent;
  return /(Chrome|CriOS)\/\S+( Mobile\S*)? Safari\/\S+$/i.test(userAgent);
}
/**
 * 是否是新版 Chromium Edge 浏览器
 */
function isChromiumEdge() {
  var userAgent = window.navigator.userAgent;
  return /Edg\//i.test(userAgent);
}
/**
 * 是否是 Firefox 浏览器
 */
function isFirefox() {
  var userAgent = window.navigator.userAgent;
  return /(Firefox|Focus|FxiOS)\//i.test(userAgent);
}
/**
 * 是否是腾讯文档桌面 app
 */
function isTencentDocDesktopApp() {
  var userAgent = window.navigator.userAgent;
  return /TDAppDesktop/i.test(userAgent);
}
/**
 * 是否是安卓平台
 * @param {user agent} ua
 */
function isAndroid() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return /android|adr/i.test(ua);
}
/**
 * 判断是否是 windows 平台
 * @param {user agent} ua
 */
function isWindows() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return /windows/i.test(ua);
}
/**
 * 是否是微信小程序
 * @param {user agent} ua
 */
function isWxMiniProgram() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  // 企业微信 iOS 比较特殊，UA 中没有小程序的字样，只能通过全局 __wxjs_environment 来判断,在QQ小程序中新建进入的详情页也会带上__wxjs_environment=miniprogram
  var wxUrlContainStr = '__wxjs_environment=miniprogram';
  // (/miniprogram|miniapp(?!enable)/i.test(ua) || window.location.href.indexOf(wxUrlContainStr) > -1)代表
  // 是否是（微信/企业微信或 QQ/TIM）的小程序 webview
  return /MicroMessenger/i.test(ua) && (/miniprogram|miniapp(?!enable)/i.test(ua) || window.location.href.indexOf(wxUrlContainStr) > -1);
}
function isQQBrowser() {
  var ua = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return /QQBrowser/i.test(ua);
}

/**
 * 两点之间的距离
 */
/**
 * 角度转弧度
 * @param angle
 */
function angleToRadian(angle) {
  return Math.PI / 180.0 * angle;
}

function updateFillTransform(imageFill, frame) {
  var t = imageFill.transform;
  var _frame$left = frame.left,
    left = _frame$left === void 0 ? 0 : _frame$left,
    _frame$top = frame.top,
    top = _frame$top === void 0 ? 0 : _frame$top,
    _frame$rotate = frame.rotate,
    rotate = _frame$rotate === void 0 ? 0 : _frame$rotate,
    scaleX = frame.scaleX,
    scaleY = frame.scaleY,
    realWidth = frame.realWidth,
    realHeight = frame.realHeight;
  t.rotation = rotate * Math.PI / 180;
  t.scaleX = scaleX;
  t.scaleY = scaleY;
  var sin = Math.sin(-t.rotation);
  var cos = Math.cos(-t.rotation);
  if (rotate >= 270 && rotate < 360) {
    t.translateX = -realHeight * sin * cos;
    t.translateY = realHeight * sin * sin;
  } else if (rotate >= 180 && rotate < 270) {
    t.translateX = realWidth * cos * cos;
    t.translateY = -realWidth * cos * sin + realHeight;
  } else if (rotate >= 90 && rotate < 180) {
    t.translateX = realHeight * cos * sin + realWidth;
    t.translateY = realHeight * cos * cos;
  } else {
    t.translateX = realWidth * sin * sin;
    t.translateY = realWidth * sin * cos;
  }
  t.translateX += left;
  t.translateY += top;
}
function updateTransformMatrix(imageFill, frame) {
  var _a;
  var fill = imageFill;
  var width = frame.width,
    height = frame.height,
    flipH = frame.flipH,
    flipV = frame.flipV,
    _frame$scaleX = frame.scaleX,
    scaleX = _frame$scaleX === void 0 ? 1 : _frame$scaleX,
    _frame$scaleY = frame.scaleY,
    scaleY = _frame$scaleY === void 0 ? 1 : _frame$scaleY,
    _frame$pathScaleX = frame.pathScaleX,
    pathScaleX = _frame$pathScaleX === void 0 ? 1 : _frame$pathScaleX,
    _frame$pathScaleY = frame.pathScaleY,
    pathScaleY = _frame$pathScaleY === void 0 ? 1 : _frame$pathScaleY,
    translateX = frame.translateX,
    translateY = frame.translateY,
    offsetFrame = frame.offsetFrame;
  fill.transform.pivotX = Math.floor(width / 2);
  fill.transform.pivotY = Math.floor(height / 2);
  fill.transform.translateX = Math.floor(width / 2);
  fill.transform.translateY = Math.floor(height / 2);
  fill.transform.scaleX = flipH ? -1 : 1;
  fill.transform.scaleY = flipV ? -1 : 1;
  updateOffsetScale(fill.transform, offsetFrame);
  var _frame$rotate2 = frame.rotate,
    rotate = _frame$rotate2 === void 0 ? 0 : _frame$rotate2;
  rotate = (_a = offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetRotate) !== null && _a !== void 0 ? _a : rotate;
  fill.transform.rotation = rotate * Math.PI / 180;
  if (pathScaleX !== 1 || pathScaleY !== 1) {
    // 自定义图形需要应用 path 的 scale
    var transform = new Transform();
    transform.scaleX = pathScaleX;
    transform.scaleY = pathScaleY;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fill.transform.matrix.append(transform.matrix).invert();
  } else {
    // 应用元素变换逆矩阵
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fill.transform.matrix.invert();
  }
  var fillTransform = new Transform();
  fillTransform.scaleX = scaleX;
  fillTransform.scaleY = scaleY;
  fillTransform.translateX = translateX;
  fillTransform.translateY = translateY;
  // 应用填充变换矩阵
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  fill.transform.matrix.append(fillTransform.matrix);
}
function getImageFrame(imageFill, bgOption) {
  var _a;
  var frameWidth = bgOption.width,
    frameHeight = bgOption.height,
    offsetFrame = bgOption.offsetFrame,
    _bgOption$rotate = bgOption.rotate,
    rotateOption = _bgOption$rotate === void 0 ? 0 : _bgOption$rotate;
  var _getImageRect = getImageRect(imageFill, frameWidth, frameHeight),
    pl = _getImageRect.pl,
    pt = _getImageRect.pt,
    width = _getImageRect.width,
    height = _getImageRect.height;
  var imgW = Math.round(width); // 图片大小取整，否则会非常模糊
  var imgH = Math.round(height);
  var imgLeft = Math.round(pl);
  var imgTop = Math.round(pt);
  var rotate = 0;
  if (!imageFill.rotateWithShape) {
    rotate = (_a = offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetRotate) !== null && _a !== void 0 ? _a : -(rotateOption % 360);
    rotate = 360 + rotate;
    if (offsetFrame) {
      // 当有offsetFrame时，需根据offsetFrame的offsetWidth和offsetHeight重新计算偏移值
      var _getImageRect2 = getImageRect(imageFill, offsetFrame.offsetWidth, offsetFrame.offsetHeight),
        _pl = _getImageRect2.pl,
        _pt = _getImageRect2.pt,
        _width = _getImageRect2.width,
        _height = _getImageRect2.height;
      imgW = Math.round(_width);
      imgH = Math.round(_height);
      imgLeft = Math.round(_pl) + offsetFrame.offsetX;
      imgTop = Math.round(_pt) + offsetFrame.offsetY;
    } else {
      var newRect = getFrameAfterRotate({
        top: 0,
        left: 0,
        width: frameWidth,
        height: frameHeight
      }, 360 - rotate);
      var _getImageRect3 = getImageRect(imageFill, newRect.width, newRect.height),
        _pl2 = _getImageRect3.pl,
        _pt2 = _getImageRect3.pt,
        _width2 = _getImageRect3.width,
        _height2 = _getImageRect3.height;
      imgW = Math.round(_width2);
      imgH = Math.round(_height2);
      imgLeft = newRect.left + Math.round(_pl2);
      imgTop = newRect.top + Math.round(_pt2);
    }
  }
  return {
    width: imgW,
    height: imgH,
    left: imgLeft,
    top: imgTop,
    rotate: rotate
  };
}
function getTileImageFrame(imageFill, bgOption) {
  var _a;
  var scaleW = bgOption.scaleW,
    scaleH = bgOption.scaleH,
    imgW = bgOption.imgW,
    imgH = bgOption.imgH,
    frameWidth = bgOption.width,
    frameHeight = bgOption.height,
    imageScaleX = bgOption.imageScaleX,
    imageScaleY = bgOption.imageScaleY;
  var width = frameWidth / scaleW;
  var height = frameHeight / scaleH;
  var rorTransX = 0;
  var rorTransY = 0;
  var rotate = 0;
  if (!imageFill.rotateWithShape) {
    var offsetFrame = bgOption.offsetFrame;
    if (offsetFrame) {
      rorTransX = offsetFrame.offsetX;
      rorTransY = offsetFrame.offsetY;
      width = offsetFrame.offsetWidth;
      height = offsetFrame.offsetHeight;
      rotate = (_a = offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetRotate) !== null && _a !== void 0 ? _a : rotate;
    } else if (bgOption.rotate > 0) {
      // 如果发现是不随形状旋转
      rotate = bgOption.rotate;
      rotate = 360 - rotate % 360;
      var oldRect = {
        left: 0,
        top: 0,
        width: width,
        height: height
      };
      var newRect = getFrameAfterRotate(oldRect, bgOption.rotate);
      rorTransX = newRect.left;
      rorTransY = newRect.top;
      width = newRect.width;
      height = newRect.height;
    }
  }
  var imgWidth = imgW * imageScaleX / scaleW;
  var imgHeight = imgH * imageScaleY / scaleH;
  var _getImgTileFlipInfo = getImgTileFlipInfo(imageFill.tile, imgWidth, imgHeight),
    pattern = _getImgTileFlipInfo.pattern;
  var patternLoc = getTileAlignLoc(imageFill.tile, imgWidth, imgHeight, width, height);
  var patternOffsetX = Math.round(patternLoc.x + rorTransX + (pattern ? pattern.translateX : 0));
  var patternOffsetY = Math.round(patternLoc.y + rorTransY + (pattern ? pattern.translateY : 0));
  return {
    width: imgWidth,
    height: imgHeight,
    left: patternOffsetX,
    top: patternOffsetY,
    rotate: rotate
  };
}
function getSrcRect(srcRect, width, height) {
  var _srcRect$l = srcRect.l,
    l = _srcRect$l === void 0 ? 0 : _srcRect$l,
    _srcRect$r = srcRect.r,
    r = _srcRect$r === void 0 ? 0 : _srcRect$r,
    _srcRect$b = srcRect.b,
    b = _srcRect$b === void 0 ? 0 : _srcRect$b,
    _srcRect$t = srcRect.t,
    t = _srcRect$t === void 0 ? 0 : _srcRect$t;
  // 当经过裁剪后，图片前景宽度/高度为0时，需要进行特殊处理
  var isMinW = Math.round((1 - l - r) * 100) / 100 === 0;
  var pl = isMinW ? -width / 2 : width * l / (1 - l - r);
  var pr = isMinW ? -width / 2 : width * r / (1 - l - r);
  var isMinH = Math.round((1 - t - b) * 100) / 100 === 0;
  var pt = isMinH ? -height / 2 : height * t / (1 - t - b);
  var pb = isMinH ? -height / 2 : height * b / (1 - t - b);
  return {
    l: pl,
    r: pr,
    t: pt,
    b: pb
  };
}
function getImageRect(image, width, height) {
  var pl = 0;
  var pt = 0;
  var pr = 0;
  var pb = 0;
  if (!image.stretch) {
    return {
      pl: pl,
      pt: pt,
      width: width,
      height: height
    };
  }
  if (image.stretch.srcRect) {
    var _getSrcRect = getSrcRect(image.stretch.srcRect, width, height),
      l = _getSrcRect.l,
      r = _getSrcRect.r,
      b = _getSrcRect.b,
      t = _getSrcRect.t;
    pl = l;
    pr = r;
    pt = t;
    pb = b;
  } else if (image.stretch.fillRect) {
    var _image$stretch$fillRe = image.stretch.fillRect,
      _image$stretch$fillRe2 = _image$stretch$fillRe.l,
      _l = _image$stretch$fillRe2 === void 0 ? 0 : _image$stretch$fillRe2,
      _image$stretch$fillRe3 = _image$stretch$fillRe.r,
      _r = _image$stretch$fillRe3 === void 0 ? 0 : _image$stretch$fillRe3,
      _image$stretch$fillRe4 = _image$stretch$fillRe.b,
      _b = _image$stretch$fillRe4 === void 0 ? 0 : _image$stretch$fillRe4,
      _image$stretch$fillRe5 = _image$stretch$fillRe.t,
      _t = _image$stretch$fillRe5 === void 0 ? 0 : _image$stretch$fillRe5;
    pl = width * _l;
    pr = width * _r;
    pt = height * _t;
    pb = height * _b;
  }
  var finalWidth = width + pl + pr;
  var finalHeight = height + pt + pb;
  if (image.stretch.fillRect) {
    var _image$stretch$fillRe6 = image.stretch.fillRect,
      _image$stretch$fillRe7 = _image$stretch$fillRe6.l,
      _l2 = _image$stretch$fillRe7 === void 0 ? 0 : _image$stretch$fillRe7,
      _image$stretch$fillRe8 = _image$stretch$fillRe6.r,
      _r2 = _image$stretch$fillRe8 === void 0 ? 0 : _image$stretch$fillRe8,
      _image$stretch$fillRe9 = _image$stretch$fillRe6.b,
      _b2 = _image$stretch$fillRe9 === void 0 ? 0 : _image$stretch$fillRe9,
      _image$stretch$fillRe10 = _image$stretch$fillRe6.t,
      _t2 = _image$stretch$fillRe10 === void 0 ? 0 : _image$stretch$fillRe10;
    // 图片填充左右偏移值之和小于 -1 时，图片宽度应为 0
    if (_l2 + _r2 < -1) {
      finalWidth = 0;
    }
    // 图片填充上下偏移值之和小于 -1 时，图片高度应为 0
    if (_b2 + _t2 < -1) {
      finalHeight = 0;
    }
  }
  pl = -pl;
  pt = -pt;
  return {
    pl: pl,
    pt: pt,
    width: finalWidth,
    height: finalHeight
  };
}
/**
 * 返回旋转之后能够包裹的新的矩形位置大小
 * @param originalFrame 原始图形位置大小
 * @param rotateAngle 顺时针旋转的角度
 * @returns {Array}
 */
function getFrameAfterRotate(originalFrame, rotateAngle) {
  var newPoints = getPointsAfterRotate(originalFrame, rotateAngle);
  var minX = Math.min(newPoints[0].x, newPoints[1].x, newPoints[2].x, newPoints[3].x);
  var minY = Math.min(newPoints[0].y, newPoints[1].y, newPoints[2].y, newPoints[3].y);
  var maxX = Math.max(newPoints[0].x, newPoints[1].x, newPoints[2].x, newPoints[3].x);
  var maxY = Math.max(newPoints[0].y, newPoints[1].y, newPoints[2].y, newPoints[3].y);
  return {
    left: minX,
    top: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
/**
 * 返回旋转之后新的矩形四个点的坐标
 * @param originalFrame 原始图形位置大小
 * @param rotateAngle 顺时针旋转的角度
 * @returns {Array}
 */
function getPointsAfterRotate(originalFrame, rotateAngle) {
  var originPoints = [{
    x: originalFrame.left,
    y: originalFrame.top
  }, {
    x: originalFrame.left + originalFrame.width,
    y: originalFrame.top
  }, {
    x: originalFrame.left + originalFrame.width,
    y: originalFrame.top + originalFrame.height
  }, {
    x: originalFrame.left,
    y: originalFrame.top + originalFrame.height
  }];
  var center = {
    x: (originalFrame.left + originalFrame.left + originalFrame.width) / 2,
    y: (originalFrame.top + originalFrame.top + originalFrame.height) / 2
  };
  var points = [];
  for (var i = 0; i < originPoints.length; i++) {
    points.push(afterRotate(originPoints[i], rotateAngle, center.x, center.y));
  }
  return points;
}
function afterRotate(position, rotate, centerX, centerY) {
  // 顺时针
  return {
    x: (position.x - centerX) * Math.cos(angleToRadian(rotate)) - (position.y - centerY) * Math.sin(angleToRadian(rotate)) + centerX,
    y: (position.y - centerY) * Math.cos(angleToRadian(rotate)) + (position.x - centerX) * Math.sin(angleToRadian(rotate)) + centerY
  };
}
function getImgTileFlipInfo(tile, imgW, imgH) {
  var flip = tile.flip;
  var algn = tile.algn;
  var doubleW = imgW * 2;
  var doubleH = imgH * 2;
  var flipInfo = {
    pattern: {
      width: imgW,
      height: imgH,
      translateX: 0,
      translateY: 0
    },
    imageArray: [{
      w: imgW,
      h: imgH,
      x: 0,
      y: 0,
      transform: ''
    }]
  };
  var imgArray = flipInfo.imageArray;
  var p = flipInfo.pattern;
  switch (flip) {
    case TilingMirror.Horizontal:
      p.width = doubleW;
      setFlipXTransX(p, algn, imgW);
      imgArray.push({
        w: imgW + 1,
        h: imgH,
        x: -doubleW,
        y: 0,
        transform: 'scale(-1,1)'
      }); // //加1是为了解决缩放的时候，可能产生的空隙
      break;
    case TilingMirror.Vertical:
      p.height = doubleH;
      setFlipYTransY(p, algn, imgH);
      imgArray.push({
        w: imgW,
        h: imgH + 1,
        x: 0,
        y: -doubleH,
        transform: 'scale(1,-1)'
      });
      break;
    case TilingMirror.Both:
      p.width = doubleW;
      p.height = doubleH;
      setTileImgPatternXY(p, algn, imgW, imgH);
      imgArray.push({
        w: imgW + 1,
        h: imgH,
        x: -doubleW,
        y: 0,
        transform: 'scale(-1,1)'
      });
      imgArray.push({
        w: imgW,
        h: imgH + 1,
        x: 0,
        y: -doubleH,
        transform: 'scale(1,-1)'
      });
      imgArray.push({
        w: imgW + 1,
        h: imgH + 1,
        x: -doubleW,
        y: -doubleH,
        transform: 'scale(-1,-1)'
      });
      break;
  }
  return flipInfo;
}
function setTileImgPatternXY(p, algn, imgW, imgH) {
  setFlipXTransX(p, algn, imgW);
  setFlipYTransY(p, algn, imgH);
}
function setFlipXTransX(p, algn, imgW) {
  if (algn === 'tr' || algn === 'br' || algn === 'r') {
    p.translateX = imgW;
  } else if (algn === 't' || algn === 'b' || algn === 'ctr') {
    p.translateX = imgW / 2;
  }
}
function setFlipYTransY(p, algn, imgH) {
  if (algn === 'bl' || algn === 'br' || algn === 'b') {
    p.translateY = imgH;
  } else if (algn === 'l' || algn === 'r' || algn === 'ctr') {
    p.translateY = imgH / 2;
  }
}
/**
 * 获取背景平铺图片对齐方式
 * @param align
 * @param imgW  图片size
 * @param imgH
 * @param width 容器大小
 * @param height
 */
function getTileAlignLoc(tileObj, imgW, imgH, width, height) {
  var x = 0;
  var y = 0;
  var align = tileObj.algn || 'tl';
  if (imgW === 0 || imgH === 0 || width === 0 || height === 0) return {
    x: x,
    y: y
  };
  // 靠4个角
  var offsetX = imgW > width ? width - imgW : width % imgW;
  var offsetY = imgH > height ? height - imgH : height % imgH;
  // 居中的offset
  var centerOffsetX = getCenterOffsetX(imgW, width);
  var centerOffsetY = getCenterOffsetY(imgH, height);
  var xyObj = getTileXY(align, offsetX, offsetY, centerOffsetX, centerOffsetY);
  x = xyObj.x;
  y = xyObj.y;
  if (tileObj.tx) {
    x += tileObj.tx;
  }
  if (tileObj.ty) {
    y += tileObj.ty;
  }
  return {
    x: x,
    y: y
  };
}
function getCenterOffsetX(imgW, width) {
  var centerOffsetX = 0;
  if (imgW > width) {
    centerOffsetX = (width - imgW) / 2;
  } else {
    var startIndex = 1; // 奇数
    while (startIndex * imgW < width) {
      startIndex += 2;
    }
    centerOffsetX = (width - startIndex * imgW) / 2;
  }
  return centerOffsetX;
}
function getCenterOffsetY(imgH, height) {
  var centerOffsetY = 0;
  if (imgH > height) {
    centerOffsetY = (height - imgH) / 2;
  } else {
    var startIndex = 1; // 奇数
    while (startIndex * imgH < height) {
      startIndex += 2;
    }
    centerOffsetY = (height - startIndex * imgH) / 2;
  }
  return centerOffsetY;
}
function getTileXY(align, offsetX, offsetY, centerOffsetX, centerOffsetY) {
  var x = 0;
  var y = 0;
  switch (align) {
    case 'tl':
      // 左对齐
      break;
    case 'tr':
      // 右对齐
      x = offsetX;
      break;
    case 'bl':
      // 左下对齐
      y = offsetY;
      break;
    case 'br':
      // 右下对齐
      x = offsetX;
      y = offsetY;
      break;
    case 't':
      // 靠上
      x = centerOffsetX;
      break;
    case 'b':
      // 靠下
      x = centerOffsetX;
      y = offsetY;
      break;
    case 'l':
      // 靠左
      y = centerOffsetY;
      break;
    case 'r':
      // 靠右
      x = offsetX;
      y = centerOffsetY;
      break;
    case 'ctr':
      // 居中
      x = centerOffsetX;
      y = centerOffsetY;
      break;
  }
  return {
    x: x,
    y: y
  };
}

function angleToVector(angle, frame, rotateWithShape) {
  var _a, _b;
  // 项目中原有计算 points 的逻辑有问题，先使用渲染层项目中的计算逻辑
  angle = (angle >= 0 ? angle : -360 * Math.floor(angle / 360) + angle) % 360;
  var a = Math.cos(angle * Math.PI / 180);
  var b = Math.sin(angle * Math.PI / 180);
  var newFrame = Object.assign(Object.assign({}, frame), {
    left: 0,
    top: 0
  });
  if (!rotateWithShape) {
    newFrame = getFrameAfterOffset(newFrame);
  }
  var _newFrame = newFrame,
    width = _newFrame.width,
    height = _newFrame.height;
  var minX = (_a = newFrame.left) !== null && _a !== void 0 ? _a : 0;
  var minY = (_b = newFrame.top) !== null && _b !== void 0 ? _b : 0;
  var maxX = minX + width;
  var maxY = minY + height;
  var p1x;
  var p1y;
  var p2x;
  var p2y;
  if (angle <= 90) {
    p1x = minX;
    p1y = minY;
    p2x = maxX;
    p2y = maxY;
  } else if (angle <= 180) {
    p1x = maxX;
    p1y = minY;
    p2x = minX;
    p2y = maxY;
  } else if (angle <= 270) {
    p1x = maxX;
    p1y = maxY;
    p2x = minX;
    p2y = minY;
  } else {
    p1x = minX;
    p1y = maxY;
    p2x = maxX;
    p2y = minY;
  }
  // 计算渐变直线与渐变起点垂线/渐变终点垂线的交点.
  // 同样使用点向式构造两条垂线的方程, 方向向量为 (b, -a), 点为 (px, py), 得到渐变起点 (x0, y0) 与终点 (x1, y1).
  // 解方程: https://www.wolframalpha.com/input?i=solve+%28y-q%29%2F-a%3D%28x-p%29%2Fb%2C%28y-u%29%2Fb%3D%28x-v%29%2Fa
  var a2 = a * a;
  var ab = a * b;
  var b2 = b * b;
  var x1 = a2 * p1x - ab * (width - p1y) + b2 * height;
  var y1 = a2 * width + ab * (p1x - height) + b2 * p1y;
  var x2 = a2 * p2x - ab * (width - p2y) + b2 * height;
  var y2 = a2 * width + ab * (p2x - height) + b2 * p2y;
  return {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  };
}
/**
 * 当元素有旋转/翻转时，需要对不跟随形状旋转的场景做逆向补偿
 */
function modifyTransform(fill, frame) {
  var _a;
  var left = frame.left,
    top = frame.top,
    width = frame.width,
    height = frame.height,
    flipH = frame.flipH,
    flipV = frame.flipV,
    _frame$scaleX = frame.scaleX,
    scaleX = _frame$scaleX === void 0 ? 1 : _frame$scaleX,
    _frame$scaleY = frame.scaleY,
    scaleY = _frame$scaleY === void 0 ? 1 : _frame$scaleY,
    offsetFrame = frame.offsetFrame;
  var _frame$rotate = frame.rotate,
    rotate = _frame$rotate === void 0 ? 0 : _frame$rotate;
  if (needModify(frame)) {
    rotate = (_a = offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetRotate) !== null && _a !== void 0 ? _a : rotate;
    fill.transform.rotation = rotate * (Math.PI / 180);
    fill.transform.translateX = Math.floor(left) + Math.floor(width / 2); // pivotX的设置会令图像产生负向平移，所以需要补回来
    fill.transform.translateY = Math.floor(top) + Math.floor(height / 2);
    fill.transform.pivotX = Math.floor(width / 2);
    fill.transform.pivotY = Math.floor(height / 2);
    fill.transform.scaleX = flipH ? -1 : 1;
    fill.transform.scaleY = flipV ? -1 : 1;
    updateOffsetScale(fill.transform, offsetFrame);
    if (scaleX !== 1 || scaleY !== 1) {
      // 自定义图形需要应用 path 的 scale
      var transform = new Transform();
      transform.scaleX = scaleX;
      transform.scaleY = scaleY;
      fill.transform.matrix.append(transform.matrix).invert();
    } else {
      // 应用元素变换逆矩阵
      fill.transform.matrix.invert();
    }
  }
}
function needModify(frame) {
  var flipH = frame.flipH,
    flipV = frame.flipV,
    offsetFrame = frame.offsetFrame,
    _frame$rotate2 = frame.rotate,
    rotate = _frame$rotate2 === void 0 ? 0 : _frame$rotate2;
  var hasScaleX = frame.scaleX && frame.scaleX !== 1;
  var hasScaleY = frame.scaleY && frame.scaleY !== 1;
  return flipH || flipV || rotate || (offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetFlipH) || (offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetFlipV) || hasScaleX || hasScaleY;
}
/**
 * 如果有传值offsetFlip，则相应的对transform.scale做翻转
 */
function updateOffsetScale(transform, offsetFrame) {
  if (offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetFlipH) {
    transform.scaleX *= -1;
  }
  if (offsetFrame === null || offsetFrame === void 0 ? void 0 : offsetFrame.offsetFlipV) {
    transform.scaleY *= -1;
  }
}
function getFrameAfterOffset(frame) {
  var offsetFrame = frame.offsetFrame;
  if (offsetFrame) {
    return {
      left: offsetFrame.offsetX,
      top: offsetFrame.offsetY,
      width: offsetFrame.offsetWidth,
      height: offsetFrame.offsetHeight
    };
  }
  return frame.rotate ? getFrameAfterRotate(frame, frame.rotate) : frame;
}

var LruCache = /*#__PURE__*/function () {
  function LruCache(capacity, deleteCallback) {
    _classCallCheck(this, LruCache);
    this.cache = new Map();
    this.capacity = capacity;
    this.deleteCallback = deleteCallback;
  }
  // 取并刷新
  return _createClass(LruCache, [{
    key: "get",
    value: function get(key) {
      if (this.cache.has(key)) {
        // 访问一次则将其置为最新的
        var value = this.cache.get(key);
        this.cache["delete"](key);
        this.cache.set(key, value);
        return value;
      }
      return null;
    }
    // 存并刷新
  }, {
    key: "put",
    value: function put(key, value) {
      if (this.cache.has(key)) {
        // 存在则先删除
        this.cache["delete"](key);
      }
      if (this.cache.size >= this.capacity) {
        // 已经超容了，则删掉最旧的数据
        this["delete"](this.cache.keys().next().value);
      }
      this.cache.set(key, value);
    }
    // 移除
  }, {
    key: "delete",
    value: function _delete(key) {
      var _a;
      if (this.cache.has(key)) {
        this.cache["delete"](key);
        (_a = this.deleteCallback) === null || _a === void 0 ? void 0 : _a.call(this, key);
      }
    }
  }]);
}();

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * 延迟请求promise的resolve以达到成批次render的效果
 * (1)以slide页为单位，一页内的图片请求均完成时则触发resolve
 * (2)以slide页为单位，一页内的图片请求只要有一张超过最大延迟阈值（比如2s），则将本页所有已完成的resolve
 */
var DelayToBatchRender = /*#__PURE__*/function () {
  function DelayToBatchRender(getTexture) {
    _classCallCheck(this, DelayToBatchRender);
    this.delayMap = new Map(); // 请求的延迟map
    this.maxDelayTime = 2000; // 单个slide页允许延迟的最大时间，超过则立即resolve，不等待本页全部图片完成
    this.slideTimerMap = new Map(); // 各页对应的最大延迟timer
    this.getTexture = getTexture;
  }
  // 将当前请求加入delay队列，没有则在队列中则新建，有则更新请求的所属slide数组
  return _createClass(DelayToBatchRender, [{
    key: "addDelayItem",
    value: function addDelayItem(params) {
      var alloyParams = params.alloyParams,
        customParams = params.customParams;
      var urlOrImage = alloyParams.urlOrImage;
      // 如果当前请求未携带从属页的信息，则暂不进行成批更新逻辑
      if (!(customParams === null || customParams === void 0 ? void 0 : customParams.slideKey)) {
        return;
      }
      // 如果当前请求已处于resolve，则也不用进行成批更新逻辑
      var texture = this.getTexture(params);
      if (texture === null || texture === void 0 ? void 0 : texture.isComplete) {
        return;
      }
      // 如果当前请求已在请求队列，但未在delay队列，说明是那种无需delay的，则依旧忽略
      if (texture && !(texture === null || texture === void 0 ? void 0 : texture.isComplete) && !this.delayMap.has(urlOrImage)) {
        return;
      }
      // 没有则在队列中则新建，有则更新请求的所属slide数组
      var delayItem = this.delayMap.get(urlOrImage);
      if (!delayItem) {
        delayItem = {
          belongToSlides: new Set(),
          downloadComplete: false,
          delayPromise: undefined,
          delayResolve: undefined
        };
        delayItem.delayPromise = new Promise(function (resolve) {
          if (delayItem) {
            delayItem.delayResolve = resolve;
          }
        });
        this.delayMap.set(urlOrImage, delayItem);
      }
      delayItem.belongToSlides.add(customParams.slideKey);
      return delayItem;
    }
    // 图片加入批量渲染机制（减少页面闪烁以及频繁render）
  }, {
    key: "wrapWithDelay",
    value: function wrapWithDelay(params, imgPromise) {
      var _this = this;
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(function (resolve, reject) {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var delayItem, res, success, texture;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // 将当前请求加入delay队列
                delayItem = this.addDelayItem(params); // 等待图片请求完成
                success = false;
                _context.prev = 2;
                _context.next = 5;
                return imgPromise;
              case 5:
                res = _context.sent;
                success = true;
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                res = _context.t0;
              case 12:
                if (!delayItem) {
                  _context.next = 18;
                  break;
                }
                // 请求完成后，将当前请求标记成已请求完
                delayItem.downloadComplete = true;
                // 计算当前是否有图片全部请求完成的slide页, 有则将对应页下的所有delayInfo.delayPromise resolve，即停止delay，让此页的所有图片一批渲染
                this.countSlideComplete();
                // 为当前各请求涉及到的slide页加入超时timer，防止部分图片请求时间太长造成整页过长的等待
                this.countSlideTimer();
                // 达到delay效果的promise
                _context.next = 18;
                return delayItem.delayPromise;
              case 18:
                // 通过delay 真正完成promise
                if (success) {
                  resolve(res);
                } else {
                  reject(res);
                }
                // 记录此promise已无需请求网络(避免被重复加入delay队列)
                texture = this.getTexture(params);
                if (texture) {
                  texture.isComplete = true;
                }
              case 21:
              case "end":
                return _context.stop();
            }
          }, _callee, this, [[2, 9]]);
        }));
      });
    }
    // 计算当前请求涉及的slide页是否有已全部加载完成的，有则批量渲染
  }, {
    key: "countSlideComplete",
    value: function countSlideComplete() {
      var _this2 = this;
      var slideCountMap = new Map();
      // 统计各slide页的请求中数量
      this.delayMap.forEach(function (delayItem) {
        var belongToSlides = delayItem.belongToSlides,
          downloadComplete = delayItem.downloadComplete;
        belongToSlides.forEach(function (slideKey) {
          var slideCount = slideCountMap.get(slideKey);
          if (!slideCount) {
            slideCount = {
              loading: 0,
              complete: 0
            };
            slideCountMap.set(slideKey, slideCount);
          }
          if (downloadComplete) {
            slideCount.complete += 1;
          } else {
            slideCount.loading += 1;
          }
        });
      });
      // 找到已全部请求完成的slide页，停止下属所有请求的delay，并从delay队列中移除
      slideCountMap.forEach(function (slideCount, slideKey) {
        if (slideCount.loading > 0) {
          return;
        }
        _this2.delayMap.forEach(function (delayItem, urlOrImage) {
          var belongToSlides = delayItem.belongToSlides,
            delayResolve = delayItem.delayResolve;
          if (belongToSlides.has(slideKey)) {
            delayResolve();
            _this2.delayMap["delete"](urlOrImage);
          }
        });
        var timer = _this2.slideTimerMap.get(slideKey);
        if (timer) {
          clearTimeout(timer);
          _this2.slideTimerMap["delete"](slideKey);
        }
      });
    }
    // 计算当前请求涉及的slide页是否有超时定时器，没有则添加，超时立即render
  }, {
    key: "countSlideTimer",
    value: function countSlideTimer() {
      var _this3 = this;
      this.delayMap.forEach(function (delayItem) {
        var belongToSlides = delayItem.belongToSlides,
          downloadComplete = delayItem.downloadComplete;
        if (downloadComplete) {
          belongToSlides.forEach(function (slideKey) {
            // 已创建过的等待即可，没创建过的立即创建
            if (_this3.slideTimerMap.has(slideKey)) {
              return;
            }
            _this3.slideTimerMap.set(slideKey, window.setTimeout(function () {
              // 超过delay的阈值则将本页所有涉及的图片均resolve
              _this3.delayMap.forEach(function (delayItem, urlOrImage) {
                var belongToSlides = delayItem.belongToSlides,
                  delayResolve = delayItem.delayResolve;
                if (belongToSlides.has(slideKey)) {
                  delayResolve();
                  _this3.delayMap["delete"](urlOrImage);
                }
              });
              _this3.slideTimerMap["delete"](slideKey);
            }, _this3.maxDelayTime));
          });
        }
      });
    }
  }]);
}();

// 下载失败最大重试次数
var MAX_RETRY_TIME = 3;
var ImageLoader = /*#__PURE__*/function () {
  function ImageLoader(url, options, svgLoadedCallback) {
    _classCallCheck(this, ImageLoader);
    this.retryTime = 0;
    this.url = url;
    this.options = options;
    this.svgLoadedCallback = svgLoadedCallback;
  }
  /**
   * 请求图片资源的统一入口（包含重试逻辑）
   * svg图片有可能不包含宽高，所以单独处理。其他类型统一创建image标签处理。
   */
  return _createClass(ImageLoader, [{
    key: "request",
    value: function request() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        var requestPromise;
        if (/\.svg/i.test(_this.url)) {
          requestPromise = _this.svgLoad(_this.url, _this.options);
        } else {
          requestPromise = _this.baseLoad(_this.url, _this.options);
        }
        requestPromise.then(function (image) {
          return resolve(image);
        })["catch"](function () {
          _this.retryTime += 1;
          if (_this.retryTime <= MAX_RETRY_TIME) {
            _this.request().then(function (image) {
              return resolve(image);
            })["catch"](function () {
              return reject();
            });
          } else {
            reject();
          }
        });
      });
    }
    /**
     * 基本类型的图片加载
     * @param url
     * @param options
     * @private
     */
  }, {
    key: "baseLoad",
    value: function baseLoad(url, options) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        if ((options === null || options === void 0 ? void 0 : options.crossOrigin) !== undefined) {
          image.crossOrigin = options.crossOrigin;
        } else {
          image.crossOrigin = 'Anonymous';
        }
        if (!!(url === null || url === void 0 ? void 0 : url.startsWith('blob:'))) {
          image.src = url.replace(/[#?].*$/, '');
        } else {
          image.src = url;
        }
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          return reject();
        };
      });
    }
    /**
     * svg单独处理
     * @param url
     * @param options
     * @private
     */
  }, {
    key: "svgLoad",
    value: function svgLoad(url, options) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onerror = reject;
        xhr.onreadystatechange = function () {
          var _a;
          if (xhr.readyState !== 4) return;
          if (xhr.status !== 200) reject(new RangeError("The image response with code ".concat(xhr.status)));
          var div = document.createElement('div');
          div.innerHTML = DOMPurify.sanitize(xhr.responseText, {
            USE_PROFILES: {
              svg: true,
              svgFilters: true
            },
            ADD_TAGS: ['use', 'foreignobject'] // 兼容被g标签包裹use标签的场景
          });
          var svg = div.querySelector(':scope > svg');
          if (!svg) return reject(new TypeError('The requested resource is not a valid SVG.'));
          var foreignObject = svg.querySelector('foreignObject');
          if (foreignObject) {
            // svg 中存在 foreignObject 会污染画布，toBlob、getImageData 等操作会报错，转为 base64 格式
            var decoded = unescape(encodeURIComponent(xhr.responseText));
            var imgSource = "data:image/svg+xml;base64,".concat(window.btoa(decoded));
            resolve(_this2.baseLoad(imgSource, options));
            (_a = _this2.svgLoadedCallback) === null || _a === void 0 ? void 0 : _a.call(_this2, url, xhr.responseText);
            return;
          }
          // 如果 SVG 图片没有显示的宽高, 帮他加一个上去
          if (!svg.hasAttribute('width') || !svg.hasAttribute('height')) {
            // 必须把 SVG 添加到 DOM 上调用 getBBox 才会有结果 (而且还不能是 display: none).
            div.style.cssText = 'position: absolute; width: 0; height: 0';
            document.body.appendChild(div);
            var _svg$getBBox = svg.getBBox(),
              width = _svg$getBBox.width,
              height = _svg$getBBox.height;
            svg.setAttribute('width', String(width));
            svg.setAttribute('height', String(height));
            document.body.removeChild(div);
          } else {
            resolve(_this2.baseLoad(url, options));
            return;
          }
          // 设置不保留 SVG 横纵比, 否则画出来的图片也会强行保留横纵比.
          svg.setAttribute('preserveAspectRatio', 'none');
          // 转 data url: https://github.com/F1LT3R/svg-to-dataurl/blob/master/index.js
          var encoded = encodeURIComponent(svg.outerHTML).replace(/'/g, '%27').replace(/"/g, '%22');
          resolve(_this2.baseLoad("data:image/svg+xml,".concat(encoded), options));
        };
        xhr.send();
      });
    }
  }]);
}();

// 图片缓存
var ImageCache = /*#__PURE__*/function () {
  function ImageCache() {
    var _this = this;
    _classCallCheck(this, ImageCache);
    // 所有图片请求状态（单个requestItem的resolve受requestDelayInfo的影响）
    this.requestListInfo = {
      requestMap: new Map(),
      isLoading: false // 是否有正在下载中的图片
    };
    // 缓存池最多允许缓存的数量
    this.cacheCapacity = 1000;
    // 加载图片重试的最大次数
    this.loadRetryMaxTime = 2;
    // 失败兜底图最大尺寸
    this.failedImageMaxSize = 500;
    // 加载失败托底图
    this.defaultFailImage = new Image();
    // 缓存key对应的删除回调
    this.keyDeleteCallBackMap = new Map();
    // 通过ImageCache中转alloy-render的image获取，同一张图片直接读取缓存
    this.get = function (params) {
      var alloyParams = params.alloyParams,
        cacheLoseCallback = params.cacheLoseCallback,
        customParams = params.customParams;
      // 生成一个缓存的key值，基于src + options，如果生成失败，则不走缓存逻辑
      var poolKey = _this.generatePoolKey(alloyParams);
      if (!poolKey) {
        return _this.loadImage(params);
      }
      // 查找此key对应的缓存，有则返回，没有则请求并缓存
      var texture = _this.cachePool.get(poolKey);
      if (!texture) {
        // 没有图片缓存则新建图片请求并缓存
        texture = _this.loadImage(params);
        _this.cachePool.put(poolKey, texture);
      } else {
        // 有图片缓存，但此图片请求还未结束，则需将此次请求记录到delay队列
        _this.delayToBatchRender.addDelayItem(params);
      }
      // 处理图片加载失败的场景
      _this.dealLoadFail(texture, customParams);
      // 记录此key对应的删除回调，当此缓存失效被删除时触发
      _this.setCacheLoseCallBack(poolKey, cacheLoseCallback);
      return texture;
    };
    // 根据入参获取当前存储的texture
    this.getTexture = function (params) {
      var alloyParams = params.alloyParams;
      var poolKey = _this.generatePoolKey(alloyParams);
      return _this.cachePool.get(poolKey);
    };
    /**
     * 设置图片加载失败兜底图
     * @param src
     */
    this.updateFailImage = function (src) {
      _this.defaultFailImage.src = src;
    };
    /**
     * 设置 svg 加载完成回调，用于上报数据，后续删除
     * @param callback
     */
    this.setSVGLoadedCallback = function (callback) {
      _this.svgLoadedCallback = callback;
    };
    // 生成一个缓存的key值，理论上应该基于src + options，不过为了requestListInfo外部获取，目前只用src
    this.generatePoolKey = function (alloyParams) {
      // 非请求型图片资源无需走缓存逻辑
      if (typeof alloyParams.urlOrImage !== 'string') {
        return null;
      }
      return alloyParams.urlOrImage;
    };
    // 记录此key对应的删除回调，当此缓存失效被删除时触发
    this.setCacheLoseCallBack = function (poolKey, cacheLoseCallback) {
      if (typeof cacheLoseCallback !== 'function') {
        return;
      }
      if (!_this.keyDeleteCallBackMap.has(poolKey)) {
        _this.keyDeleteCallBackMap.set(poolKey, new Set());
      }
      _this.keyDeleteCallBackMap.get(poolKey).add(cacheLoseCallback);
    };
    // lru缓存失效回调，在此回调中执行调用方传入的监听
    this.runCacheLoseCallBack = function (losePoolKey) {
      if (_this.keyDeleteCallBackMap.has(losePoolKey)) {
        // 遍历所有get时传入的删除回调并执行
        _this.keyDeleteCallBackMap.get(losePoolKey).forEach(function (cacheLoseCallback) {
          if (typeof cacheLoseCallback === 'function') {
            cacheLoseCallback({
              urlOrImage: losePoolKey
            });
          }
        });
        _this.keyDeleteCallBackMap["delete"](losePoolKey);
      }
    };
    // 初始化缓存池
    this.cachePool = new LruCache(this.cacheCapacity, this.runCacheLoseCallBack);
    // 初始化批量刷新插件
    this.delayToBatchRender = new DelayToBatchRender(this.getTexture.bind(this));
  }
  // 处理图片加载失败的场景
  return _createClass(ImageCache, [{
    key: "dealLoadFail",
    value: function dealLoadFail(texture, failParams) {
      var _this2 = this;
      // 加入失败的监听（此处无需担心多次get会重复注册，alloy-render在promise失败后会把promise置为null）
      texture.onImageErrored(function () {
        texture.hasLoadFailed = true;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        texture.onImageLoaded = function () {};
        _this2.showFailImg(failParams);
      });
      // 后续图形刷新时，如果此texture已是失败的了，直接展示失败图
      if (texture.hasLoadFailed) {
        this.showFailImg(failParams);
      }
    }
    // 给图形设置失败兜底图
  }, {
    key: "showFailImg",
    value: function showFailImg(customParams) {
      var _ref = customParams !== null && customParams !== void 0 ? customParams : {},
        svgGraphics = _ref.svgGraphics,
        alpha = _ref.alpha;
      var image = new ImageResource(this.defaultFailImage);
      if (svgGraphics) {
        var texture = new ImageFill$1(image);
        var width = svgGraphics.width,
          height = svgGraphics.height;
        var minGraphicsSize = Math.min(width, height);
        var imgSize = Math.min(this.failedImageMaxSize, minGraphicsSize);
        texture.transform.translateX = width / 2 - imgSize / 2;
        texture.transform.translateY = height / 2 - imgSize / 2;
        texture.transform.scaleX = imgSize / width;
        texture.transform.scaleY = imgSize / height;
        texture.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
        svgGraphics.fill = texture;
      }
      return image;
    }
    // 加载图片（本地图片直接返回、网络图片下载）
  }, {
    key: "loadImage",
    value: function loadImage(params) {
      var alloyParams = params.alloyParams;
      var options = alloyParams.options,
        urlOrImage = alloyParams.urlOrImage;
      // 如果是文件，直接创建即可
      if (typeof urlOrImage !== 'string') {
        return new ImageResource(urlOrImage);
      }
      // 如果是url，则需要通过new Image来下载此图片
      // (1)限制图片的分辨率
      // const limitUrl = this.limitImageQuality(urlOrImage);
      // (2)创建图片资源请求，返回promise（包含重试）
      var imgPromise = new ImageLoader(urlOrImage, options, this.svgLoadedCallback).request();
      // (3)二次封装promise，以达到同一页的图片批量更新，从而降低更新频率
      imgPromise = this.delayToBatchRender.wrapWithDelay(params, imgPromise);
      // (4)追加promise结束后更新全局的请求状态的操作，方便外部获取图片的请求中状态
      this.listenRequestComplete(imgPromise, alloyParams);
      // (5)包装成alloy-render所需格式
      return new ImageResource(imgPromise);
    }
    // 变更当前全局图片加载中的状态
  }, {
    key: "listenRequestComplete",
    value: function listenRequestComplete(imgPromise, params) {
      var _this3 = this;
      this.requestListInfo.requestMap.set(params.urlOrImage, imgPromise);
      this.requestListInfo.isLoading = true;
      imgPromise
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      ["catch"](function () {}).then(function () {
        imgPromise.isComplete = true;
        _this3.requestListInfo.isLoading = Array.from(_this3.requestListInfo.requestMap.values()).some(function (req) {
          return !req.isComplete;
        });
        if (!_this3.requestListInfo.isLoading) {
          _this3.requestListInfo.requestMap.clear();
        }
      });
    }
  }]);
}();
var imageCache = new ImageCache();

var PatternFill = /*#__PURE__*/function () {
  function PatternFill() {
    _classCallCheck(this, PatternFill);
  }
  return _createClass(PatternFill, null, [{
    key: "setPatternFillStyle",
    value: function setPatternFillStyle(svgGraphics, patternFill, config) {
      if (!patternFill) {
        return;
      }
      var graphics = svgGraphics;
      var patternSvgUrl = PatternFill.getPatternSvgUrl(patternFill, config);
      var image = imageCache.get({
        alloyParams: {
          urlOrImage: patternSvgUrl
        },
        cacheLoseCallback: this.getCacheLoseCallback(patternSvgUrl)
      });
      var useResource = UserAgent.isChrome || UserAgent.isFirefox || UserAgent.isTencentDocDesktopApp || UserAgent.isWindowWxMiniProgram || UserAgent.isAndroid;
      var imageFill = new TilingImageFill(image, TilingRepeat.Both, TilingMirror.None, useResource);
      image.onImageLoaded(function () {
        var _a, _b;
        var newFrame = getFrameAfterOffset(config.frame);
        modifyTransform(imageFill, Object.assign(Object.assign({}, config.frame), {
          left: -newFrame.left,
          top: -newFrame.top,
          scaleX: (_a = config.scaleX) !== null && _a !== void 0 ? _a : 1,
          scaleY: (_b = config.scaleY) !== null && _b !== void 0 ? _b : 1
        }));
        graphics.fill = imageFill;
      });
    }
  }, {
    key: "getPatternSvgUrl",
    value: function getPatternSvgUrl(patternFill, config) {
      var bgColor = generateColorWithFillMode(patternFill.bgColor, config.fillMode);
      var fgColor = generateColorWithFillMode(patternFill.fgColor, config.fillMode);
      var fill = {
        preset: patternFill.preset,
        bgColor: getRenderColor(bgColor),
        fgColor: getRenderColor(fgColor)
      };
      var _patternFill$pageScal = patternFill.pageScale,
        pageScale = _patternFill$pageScal === void 0 ? 1 : _patternFill$pageScal;
      var uniqueKey = PatternFill.generateUniqueKey(fill, pageScale);
      var patternSvgUrl;
      if (PatternFill.patternSvgUrlMap.has(uniqueKey)) {
        patternSvgUrl = PatternFill.patternSvgUrlMap.get(uniqueKey);
      } else {
        var patternSvgString = generatePatternSvgString(fill, pageScale);
        patternSvgUrl = "data:image/svg+xml;base64,".concat(window.btoa(patternSvgString));
        PatternFill.patternSvgUrlMap.set(uniqueKey, patternSvgUrl);
      }
      return patternSvgUrl;
    }
  }, {
    key: "getCacheLoseCallback",
    value: function getCacheLoseCallback(patternSvgUrl) {
      return function () {
        PatternFill.patternSvgUrlMap["delete"](patternSvgUrl);
      };
    }
  }, {
    key: "generateUniqueKey",
    value: function generateUniqueKey(fill, pageScale) {
      var preset = fill.preset,
        fgColor = fill.fgColor,
        bgColor = fill.bgColor;
      return "".concat(preset, "_").concat(fgColor === null || fgColor === void 0 ? void 0 : fgColor.hex, "_").concat(bgColor === null || bgColor === void 0 ? void 0 : bgColor.hex, "_").concat(pageScale);
    }
  }]);
}();
PatternFill.patternSvgUrlMap = new Map();

var GradientType$1;
(function (GradientType) {
  /**
   * 线性渐变
   */
  GradientType["Linear"] = "linear";
  /**
   * 径向渐变
   */
  GradientType["Radial"] = "circle";
  /**
   * 矩形渐变
   */
  GradientType["Rect"] = "rect";
  /**
   * 路径渐变
   */
  GradientType["Shape"] = "shape";
})(GradientType$1 || (GradientType$1 = {}));

/**
 * 按比例放大三角形
 * @param triangleVertices
 * @param kx
 * @param ky
 */
function zoomTriangle(triangleVertices, kx, ky) {
  var _triangleVertices = _slicedToArray(triangleVertices, 6),
    x1 = _triangleVertices[0],
    y1 = _triangleVertices[1],
    x2 = _triangleVertices[2],
    y2 = _triangleVertices[3],
    x3 = _triangleVertices[4],
    y3 = _triangleVertices[5];
  var center = {
    x: 1 / 3 * (x1 + x2 + x3),
    y: 1 / 3 * (y1 + y2 + y3)
  };
  triangleVertices[0] = kx * (x1 - center.x) + center.x;
  triangleVertices[1] = ky * (y1 - center.y) + center.y;
  triangleVertices[2] = kx * (x2 - center.x) + center.x;
  triangleVertices[3] = ky * (y2 - center.y) + center.y;
  triangleVertices[4] = kx * (x3 - center.x) + center.x;
  triangleVertices[5] = ky * (y3 - center.y) + center.y;
}
/**
 * 根据路径顶点划分三角形，其中第一个顶点为中心点
 * @param shapeVertices
 * @param kx
 * @param ky
 */
function getTriangleVertices(shapeVertices, kx, ky) {
  var triangleArray = [];
  var len = shapeVertices.length;
  for (var i = 1; i < len - 1; i++) {
    var j = i + 1;
    var triangleVertices = [];
    triangleVertices.push(shapeVertices[0][0], shapeVertices[0][1], shapeVertices[i][0], shapeVertices[i][1], shapeVertices[j][0], shapeVertices[j][1]);
    zoomTriangle(triangleVertices, kx, ky);
    triangleArray.push(triangleVertices);
  }
  return triangleArray;
}
/**
 * 获取垂线交点
 * @param vertices
 */
function getPerpendicularPoint(vertices) {
  var _vertices = _slicedToArray(vertices, 6),
    x1 = _vertices[0],
    y1 = _vertices[1],
    x2 = _vertices[2],
    y2 = _vertices[3],
    x3 = _vertices[4],
    y3 = _vertices[5];
  var x4;
  var y4;
  if (x2 === x3) {
    x4 = x2;
    y4 = y1;
  } else if (y2 === y3) {
    x4 = x1;
    y4 = y2;
  } else {
    // 计算直线上的斜率
    var k = (y3 - y2) / (x3 - x2);
    // 计算直线方程的截距
    var b = y2 - k * x2;
    // 计算垂线方程的斜率
    var k2 = -1 / k;
    // 计算垂线方程的截距
    var b2 = y1 - k2 * x1;
    // 解方程得到垂足点的坐标
    x4 = (b2 - b) / (k - k2);
    y4 = k * x4 + b;
  }
  return [{
    x: x1,
    y: y1
  }, {
    x: x4,
    y: y4
  }];
}

var GraphicsType;
(function (GraphicsType) {
  /**
   * 线条
   */
  GraphicsType["LINE"] = "line";
  /**
   * 直线
   */
  GraphicsType["STRAIGHT_CONNECTOR"] = "straightConnector1";
  /**
   * 无控制点折线
   */
  GraphicsType["BENT_CONNECTOR_0"] = "bentConnector2";
  /**
   * 单控制点折线
   */
  GraphicsType["BENT_CONNECTOR_1"] = "bentConnector3";
  /**
   * 双控制点折线
   */
  GraphicsType["BENT_CONNECTOR_2"] = "bentConnector4";
  /**
   * 三控制点折线
   */
  GraphicsType["BENT_CONNECTOR_3"] = "bentConnector5";
  /**
   * 无控制点曲线
   */
  GraphicsType["CURVED_CONNECTOR_0"] = "curvedConnector2";
  /**
   * 单控制点曲线
   */
  GraphicsType["CURVED_CONNECTOR_1"] = "curvedConnector3";
  /**
   * 双控制点曲线
   */
  GraphicsType["CURVED_CONNECTOR_2"] = "curvedConnector4";
  /**
   * 三控制点曲线
   */
  GraphicsType["CURVED_CONNECTOR_3"] = "curvedConnector5";
  /**
   * 自定义图形
   */
  GraphicsType["CUSTOM"] = "custom";
  /**
   * 矩形
   */
  GraphicsType["RECT"] = "rect";
  /**
   * 矩形 = 圆角
   */
  GraphicsType["ROUND_RECT"] = "roundRect";
  /**
   * 矩形 = 剪去单角
   */
  GraphicsType["SNIP_SINGLE_RECT"] = "snip1Rect";
  /**
   * 矩形 = 剪去顶角
   */
  GraphicsType["SNIP_SAME_SIDE_RECT"] = "snip2SameRect";
  /**
   * 矩形 = 剪去对角
   */
  GraphicsType["SNIP_DIAG_RECT"] = "snip2DiagRect";
  /**
   * 矩形：一个圆顶角，剪去另一个顶角
   */
  GraphicsType["SNIP_ROUND_RECT"] = "snipRoundRect";
  /**
   * 矩形：单圆角
   */
  GraphicsType["ROUND_SINGLE_RECT"] = "round1Rect";
  /**
   * 矩形：圆顶角
   */
  GraphicsType["ROUND_SAME_SIDE_RECT"] = "round2SameRect";
  /**
   * 矩形：对角圆角
   */
  GraphicsType["ROUND_DIAG_RECT"] = "round2DiagRect";
  /**
   * 椭圆
   */
  GraphicsType["ELLIPSE"] = "ellipse";
  /**
   * 等腰三角形
   */
  GraphicsType["TRIANGLE"] = "triangle";
  /**
   * 直角三角形
   */
  GraphicsType["RIGHT_TRIANGLE"] = "rtTriangle";
  /**
   * 平行四边形
   */
  GraphicsType["PARALLELOGRAM"] = "parallelogram";
  /**
   * 菱形
   */
  GraphicsType["DIAMOND"] = "diamond";
  /**
   * 梯形
   */
  GraphicsType["TRAPEZOID"] = "trapezoid";
  /**
   * 五边形
   */
  GraphicsType["PENTAGON"] = "pentagon";
  /**
   * 六边形
   */
  GraphicsType["HEXAGON"] = "hexagon";
  /**
   * 七边形
   */
  GraphicsType["HEPTAGON"] = "heptagon";
  /**
   * 八边形
   */
  GraphicsType["OCTAGON"] = "octagon";
  /**
   * 十边形
   */
  GraphicsType["DECAGON"] = "decagon";
  /**
   * 十二边形
   */
  GraphicsType["DODECAGON"] = "dodecagon";
  /**
   * 不完整圆
   */
  GraphicsType["PIE"] = "pie";
  /**
   * 弦形
   */
  GraphicsType["CHORD"] = "chord";
  /**
   * 泪滴形
   */
  GraphicsType["TEARDROP"] = "teardrop";
  /**
   * 图文框
   */
  GraphicsType["FRAME"] = "frame";
  /**
   * 半闭框
   */
  GraphicsType["HALF_FRAME"] = "halfFrame";
  /**
   * L形
   */
  GraphicsType["CORNER"] = "corner";
  /**
   * 斜纹
   */
  GraphicsType["DIAG_STRIPE"] = "diagStripe";
  /**
   * 十字形
   */
  GraphicsType["PLUS"] = "plus";
  /**
   * 缺角矩形
   */
  GraphicsType["PLAQUE"] = "plaque";
  /**
   * 立方体
   */
  GraphicsType["CUBE"] = "cube";
  /**
   * 圆柱形
   */
  GraphicsType["CAN"] = "can";
  /**
   * 矩形：棱台
   */
  GraphicsType["BEVEL"] = "bevel";
  /**
   * 圆：空心
   */
  GraphicsType["DONUT"] = "donut";
  /**
   * 禁止符
   */
  GraphicsType["NOT_ALLOWED"] = "noSmoking";
  /**
   * 空心弧
   */
  GraphicsType["BLOCK_ARC"] = "blockArc";
  /**
   * 矩形：折角
   */
  GraphicsType["FOLDED_CORNER"] = "foldedCorner";
  /**
   * 笑脸
   */
  GraphicsType["SMILEY_FACE"] = "smileyFace";
  /**
   * 心形
   */
  GraphicsType["HEART"] = "heart";
  /**
   * 闪电形
   */
  GraphicsType["LIGHTNING_BOLT"] = "lightningBolt";
  /**
   * 太阳形
   */
  GraphicsType["SUN"] = "sun";
  /**
   * 新月形
   */
  GraphicsType["MOON"] = "moon";
  /**
   * 云形
   */
  GraphicsType["CLOUD"] = "cloud";
  /**
   * 弧形
   */
  GraphicsType["ARC"] = "arc";
  /**
   * 矩左中框号
   */
  GraphicsType["LEFT_BRACKET"] = "leftBracket";
  /**
   * 右中括号
   */
  GraphicsType["RIGHT_BRACKET"] = "rightBracket";
  /**
   * 左大括号
   */
  GraphicsType["LEFT_BRACE"] = "leftBrace";
  /**
   * 右大括号
   */
  GraphicsType["RIGHT_BRACE"] = "rightBrace";
  /**
   * 双括号
   */
  GraphicsType["BRACKET_PAIR"] = "bracketPair";
  /**
   * 双大括号
   */
  GraphicsType["BRACE_PAIR"] = "bracePair";
  /**
   * 箭头：右
   */
  GraphicsType["RIGHT_ARROW"] = "rightArrow";
  /**
   * 箭头：左
   */
  GraphicsType["LEFT_ARROW"] = "leftArrow";
  /**
   * 箭头：上
   */
  GraphicsType["UP_ARROW"] = "upArrow";
  /**
   * 箭头：下
   */
  GraphicsType["DOWN_ARROW"] = "downArrow";
  /**
   * 箭头：虚尾
   */
  GraphicsType["STRIPED_RIGHT_ARROW"] = "stripedRightArrow";
  /**
   * 箭头：燕尾形
   */
  GraphicsType["NOTCHED_RIGHT_ARROW"] = "notchedRightArrow";
  /**
   * 箭头：直角上
   */
  GraphicsType["BENT_UP_ARROW"] = "bentUpArrow";
  /**
   * 箭头：左右
   */
  GraphicsType["LEFT_RIGHT_ARROW"] = "leftRightArrow";
  /**
   * 箭头：上下
   */
  GraphicsType["UP_DOWN_ARROW"] = "upDownArrow";
  /**
   * 箭头：直角双向
   */
  GraphicsType["LEFT_UP_ARROW"] = "leftUpArrow";
  /**
   * 箭头：丁字
   */
  GraphicsType["LEFT_RIGHT_UP_ARROW"] = "leftRightUpArrow";
  /**
   * 箭头：十字
   */
  GraphicsType["QUAD_ARROW"] = "quadArrow";
  /**
   * 箭头：圆角右
   */
  GraphicsType["BENT_ARROW"] = "bentArrow";
  /**
   * 箭头：手杖形
   */
  GraphicsType["U_TURN_ARROW"] = "uturnArrow";
  /**
   * 箭头：右弧形
   */
  GraphicsType["CURVED_RIGHT_ARROW"] = "curvedRightArrow";
  /**
   * 箭头：左弧形
   */
  GraphicsType["CURVED_LEFT_ARROW"] = "curvedLeftArrow";
  /**
   * 箭头：下弧形
   */
  GraphicsType["CURVED_UP_ARROW"] = "curvedUpArrow";
  /**
   * 箭头：上弧形
   */
  GraphicsType["CURVED_DOWN_ARROW"] = "curvedDownArrow";
  /**
   * 加号
   */
  GraphicsType["MATH_PLUS"] = "mathPlus";
  /**
   * 减号
   */
  GraphicsType["MATH_MINUS"] = "mathMinus";
  /**
   * 乘号
   */
  GraphicsType["MATH_MULTIPLY"] = "mathMultiply";
  /**
   * 除号
   */
  GraphicsType["MATH_DIVIDE"] = "mathDivide";
  /**
   * 等号
   */
  GraphicsType["MATH_EQUAL"] = "mathEqual";
  /**
   * 不等号
   */
  GraphicsType["MATH_NOT_EQUAL"] = "mathNotEqual";
  /**
   * 爆炸型1
   */
  GraphicsType["IRREGULAR_SEAL_1"] = "irregularSeal1";
  /**
   * 爆炸型2
   */
  GraphicsType["IRREGULAR_SEAL_2"] = "irregularSeal2";
  /**
   * 星形：四角
   */
  GraphicsType["STAR_4"] = "star4";
  /**
   * 星形：五角
   */
  GraphicsType["STAR_5"] = "star5";
  /**
   * 星形：六角
   */
  GraphicsType["STAR_6"] = "star6";
  /**
   * 星形：七角
   */
  GraphicsType["STAR_7"] = "star7";
  /**
   * 星形：八角
   */
  GraphicsType["STAR_8"] = "star8";
  /**
   * 星形：十角
   */
  GraphicsType["STAR_10"] = "star10";
  /**
   * 星形：十二角
   */
  GraphicsType["STAR_12"] = "star12";
  /**
   * 星形：十六角
   */
  GraphicsType["STAR_16"] = "star16";
  /**
   * 星形：二十四角
   */
  GraphicsType["STAR_24"] = "star24";
  /**
   * 星形：三十二角
   */
  GraphicsType["STAR_32"] = "star32";
  /**
   * 带形：前凸
   */
  GraphicsType["RIBBON"] = "ribbon";
  /**
   * 带形：上凸
   */
  GraphicsType["RIBBON_2"] = "ribbon2";
  /**
   * 带形：前凸弯
   */
  GraphicsType["ELLIPSE_RIBBON"] = "ellipseRibbon";
  /**
   * 带形：上凸弯
   */
  GraphicsType["ELLIPSE_RIBBON_2"] = "ellipseRibbon2";
  /**
   * 带形：左右弯
   */
  GraphicsType["LEFT_RIGHT_RIBBON"] = "leftRightRibbon";
  /**
   * 卷形：垂直
   */
  GraphicsType["VERTICAL_SCROLL"] = "verticalScroll";
  /**
   * 卷形：水平
   */
  GraphicsType["HORIZONTAL_SCROLL"] = "horizontalScroll";
  /**
   * 波形
   */
  GraphicsType["WAVE"] = "wave";
  /**
   * 双波形
   */
  GraphicsType["DOUBLE_WAVE"] = "doubleWave";
  /**
   * 标注：线形(无边框)
   */
  GraphicsType["CALLOUT_1"] = "callout1";
  /**
   * 标注：弯曲线形(无边框)
   */
  GraphicsType["CALLOUT_2"] = "callout2";
  /**
   * 标注：双弯曲线形(无边框)
   */
  GraphicsType["CALLOUT_3"] = "callout3";
  /**
   * 标注：线形
   */
  GraphicsType["ACCENT_CALLOUT_1"] = "accentCallout1";
  /**
   * 标注：弯曲线形
   */
  GraphicsType["ACCENT_CALLOUT_2"] = "accentCallout2";
  /**
   * 标注：双弯曲线形
   */
  GraphicsType["ACCENT_CALLOUT_3"] = "accentCallout3";
  /**
   * 标注：线形(带强调线)
   */
  GraphicsType["BORDER_CALLOUT_1"] = "borderCallout1";
  /**
   * 标注：弯曲线形(带强调线)
   */
  GraphicsType["BORDER_CALLOUT_2"] = "borderCallout2";
  /**
   * 标注：双弯曲线形(带强调线)
   */
  GraphicsType["BORDER_CALLOUT_3"] = "borderCallout3";
  /**
   * 标注：线形(带边框和强调线)
   */
  GraphicsType["ACCENT_BORDER_CALLOUT_1"] = "accentBorderCallout1";
  /**
   * 标注：弯曲线形(带边框和强调线)
   */
  GraphicsType["ACCENT_BORDER_CALLOUT_2"] = "accentBorderCallout2";
  /**
   * 标注：双弯曲线形(带边框和强调线)
   */
  GraphicsType["ACCENT_BORDER_CALLOUT_3"] = "accentBorderCallout3";
  /**
   * 对话气泡：矩形
   */
  GraphicsType["WEDGE_RECT_CALLOUT"] = "wedgeRectCallout";
  /**
   * 对话气泡：圆角矩形
   */
  GraphicsType["WEDGE_ROUND_RECT_CALLOUT"] = "wedgeRoundRectCallout";
  /**
   * 对话气泡：圆形
   */
  GraphicsType["WEDGE_ELLIPSE_CALLOUT"] = "wedgeEllipseCallout";
  /**
   * 思想气泡：云
   */
  GraphicsType["CLOUD_CALLOUT"] = "cloudCallout";
  /**
   * 流程图：过程
   */
  GraphicsType["FLOW_CHART_PROCESS"] = "flowChartProcess";
  /**
   * 流程图：决策
   */
  GraphicsType["FLOW_CHART_DECISION"] = "flowChartDecision";
  /**
   * 流程图：数据
   */
  GraphicsType["FLOW_CHART_INPUT_OUTPUT"] = "flowChartInputOutput";
  /**
   * 流程图：预定义过程
   */
  GraphicsType["FLOW_CHART_PREDEFINED_PROCESS"] = "flowChartPredefinedProcess";
  /**
   * 流程图：内部贮存
   */
  GraphicsType["FLOW_CHART_INTERNAL_STORAGE"] = "flowChartInternalStorage";
  /**
   * 流程图：文档
   */
  GraphicsType["FLOW_CHART_DOCUMENT"] = "flowChartDocument";
  /**
   * 流程图：多文档
   */
  GraphicsType["FLOW_CHART_MULTI_DOCUMENT"] = "flowChartMultidocument";
  /**
   * 流程图：终止
   */
  GraphicsType["FLOW_CHART_TERMINATOR"] = "flowChartTerminator";
  /**
   * 流程图：准备
   */
  GraphicsType["FLOW_CHART_PREPARATION"] = "flowChartPreparation";
  /**
   * 流程图：手动输入
   */
  GraphicsType["FLOW_CHART_MANUAL_INPUT"] = "flowChartManualInput";
  /**
   * 流程图：手动操作
   */
  GraphicsType["FLOW_CHART_MANUAL_OPERATION"] = "flowChartManualOperation";
  /**
   * 流程图：接点
   */
  GraphicsType["FLOW_CHART_CONNECTOR"] = "flowChartConnector";
  /**
   * 流程图：卡片
   */
  GraphicsType["FLOW_CHART_PUNCHED_CARD"] = "flowChartPunchedCard";
  /**
   * 流程图：资料带
   */
  GraphicsType["FLOW_CHART_PUNCHED_TAPE"] = "flowChartPunchedTape";
  /**
   * 流程图：汇总连接
   */
  GraphicsType["FLOW_CHART_SUMMING_JUNCTION"] = "flowChartSummingJunction";
  /**
   * 流程图：或者
   */
  GraphicsType["FLOW_CHART_OR"] = "flowChartOr";
  /**
   * 流程图：对照
   */
  GraphicsType["FLOW_CHART_COLLATE"] = "flowChartCollate";
  /**
   * 流程图：排序
   */
  GraphicsType["FLOW_CHART_SORT"] = "flowChartSort";
  /**
   * 流程图：摘录
   */
  GraphicsType["FLOW_CHART_EXTRACT"] = "flowChartExtract";
  /**
   * 流程图：合并
   */
  GraphicsType["FLOW_CHART_MERGE"] = "flowChartMerge";
  /**
   * 流程图：离线存储
   */
  GraphicsType["FLOW_CHART_OFFLINE_STORAGE"] = "flowChartOfflineStorage";
  /**
   * 流程图：存储数据
   */
  GraphicsType["FLOW_CHART_ONLINE_STORAGE"] = "flowChartOnlineStorage";
  /**
   * 流程图：顺序访问存储器
   */
  GraphicsType["FLOW_CHART_MAGNETIC_TAPE"] = "flowChartMagneticTape";
  /**
   * 流程图：磁盘
   */
  GraphicsType["FLOW_CHART_MAGNETIC_DISK"] = "flowChartMagneticDisk";
  /**
   * 流程图：直接访问存储器
   */
  GraphicsType["FLOW_CHART_MAGNETIC_DRUM"] = "flowChartMagneticDrum";
  /**
   * 流程图：显示
   */
  GraphicsType["FLOW_CHART_DISPLAY"] = "flowChartDisplay";
  /**
   * 流程图：延期
   */
  GraphicsType["FLOW_CHART_DELAY"] = "flowChartDelay";
  /**
   * 流程图：可选过程
   */
  GraphicsType["FLOW_CHART_ALTERNATE_PROCESS"] = "flowChartAlternateProcess";
  /**
   * 流程图：离页连接符
   */
  GraphicsType["FLOW_CHART_OFF_PAGE_CONNECTOR"] = "flowChartOffpageConnector";
  /**
   * 主页
   */
  GraphicsType["ACTION_BUTTON_HOME"] = "actionButtonHome";
  /**
   * 帮助
   */
  GraphicsType["ACTION_BUTTON_HELP"] = "actionButtonHelp";
  /**
   * 信息
   */
  GraphicsType["ACTION_BUTTON_INFORMATION"] = "actionButtonInformation";
  /**
   * 下一个
   */
  GraphicsType["ACTION_BUTTON_FORWARD_NEXT"] = "actionButtonForwardNext";
  /**
   * 上一个
   */
  GraphicsType["ACTION_BUTTON_BACK_PREVIOUS"] = "actionButtonBackPrevious";
  /**
   * 结束
   */
  GraphicsType["ACTION_BUTTON_END"] = "actionButtonEnd";
  /**
   * 开始
   */
  GraphicsType["ACTION_BUTTON_BEGINNING"] = "actionButtonBeginning";
  /**
   * 返回
   */
  GraphicsType["ACTION_BUTTON_RETURN"] = "actionButtonReturn";
  /**
   * 文档
   */
  GraphicsType["ACTION_BUTTON_DOCUMENT"] = "actionButtonDocument";
  /**
   * 声音
   */
  GraphicsType["ACTION_BUTTON_SOUND"] = "actionButtonSound";
  /**
   * 电影
   */
  GraphicsType["ACTION_BUTTON_MOVIE"] = "actionButtonMovie";
  GraphicsType["ACTION_BUTTON_BLANK"] = "actionButtonBlank";
  GraphicsType["HOME_PLATE"] = "homePlate";
  // 以下形状应该是其他版本 office 中的形状
  GraphicsType["GEAR_6"] = "gear6";
  GraphicsType["GEAR_9"] = "gear9";
  GraphicsType["FUNNEL"] = "funnel";
  GraphicsType["CORNER_TABS"] = "cornerTabs";
  GraphicsType["SQUARE_TABS"] = "squareTabs";
  GraphicsType["PLAQUE_TABS"] = "plaqueTabs";
  GraphicsType["CHART_X"] = "chartX";
  GraphicsType["CHART_STAR"] = "chartStar";
  GraphicsType["CHART_PLUS"] = "chartPlus";
  GraphicsType["CHEVRON"] = "chevron";
  GraphicsType["PIE_WEDGE"] = "pieWedge";
  GraphicsType["LEFT_ARROW_CALLOUT"] = "leftArrowCallout";
  GraphicsType["RIGHT_ARROW_CALLOUT"] = "rightArrowCallout";
  GraphicsType["UP_ARROW_CALLOUT"] = "upArrowCallout";
  GraphicsType["DOWN_ARROW_CALLOUT"] = "downArrowCallout";
  GraphicsType["LEFT_RIGHT_ARROW_CALLOUT"] = "leftRightArrowCallout";
  GraphicsType["UP_DOWN_ARROW_CALLOUT"] = "upDownArrowCallout";
  GraphicsType["QUAD_ARROW_CALLOUT"] = "quadArrowCallout";
  GraphicsType["LINE_INV"] = "lineInv";
  GraphicsType["NON_ISOSCELES_TRAPEZOID"] = "nonIsoscelesTrapezoid";
  GraphicsType["SWOOSH_ARROW"] = "swooshArrow";
  GraphicsType["CIRCULAR_ARROW"] = "circularArrow";
  GraphicsType["LEFT_CIRCULAR_ARROW"] = "leftCircularArrow";
  GraphicsType["LEFT_RIGHT_CIRCULAR_ARROW"] = "leftRightCircularArrow";
})(GraphicsType || (GraphicsType = {}));

/**
 * 对齐客户端路径渐变需要显示为矩形渐变的形状类型
 */
var RenderRectGradientType = [GraphicsType.ACTION_BUTTON_HOME, GraphicsType.ACTION_BUTTON_HELP, GraphicsType.ACTION_BUTTON_INFORMATION, GraphicsType.ACTION_BUTTON_FORWARD_NEXT, GraphicsType.ACTION_BUTTON_BACK_PREVIOUS, GraphicsType.ACTION_BUTTON_END, GraphicsType.ACTION_BUTTON_BEGINNING, GraphicsType.ACTION_BUTTON_RETURN, GraphicsType.ACTION_BUTTON_DOCUMENT, GraphicsType.ACTION_BUTTON_SOUND, GraphicsType.ACTION_BUTTON_MOVIE, GraphicsType.CUBE, GraphicsType.FRAME, GraphicsType.BEVEL];
/**
 * 对齐客户端路径渐变需要显示为径向渐变的形状类型
 */
var RenderRadialGradientType = [GraphicsType.DONUT, GraphicsType.NOT_ALLOWED, GraphicsType.BLOCK_ARC, GraphicsType.SMILEY_FACE, GraphicsType.LIGHTNING_BOLT, GraphicsType.SUN, GraphicsType.MOON, GraphicsType.LEFT_BRACE, GraphicsType.RIGHT_BRACE, GraphicsType.BRACE_PAIR, GraphicsType.RIGHT_ARROW, GraphicsType.LEFT_ARROW, GraphicsType.UP_ARROW, GraphicsType.DOWN_ARROW, GraphicsType.STRIPED_RIGHT_ARROW, GraphicsType.NOTCHED_RIGHT_ARROW, GraphicsType.BENT_UP_ARROW, GraphicsType.LEFT_RIGHT_ARROW, GraphicsType.UP_DOWN_ARROW, GraphicsType.LEFT_UP_ARROW, GraphicsType.LEFT_RIGHT_UP_ARROW, GraphicsType.QUAD_ARROW, GraphicsType.BENT_ARROW, GraphicsType.U_TURN_ARROW, GraphicsType.CURVED_RIGHT_ARROW, GraphicsType.CURVED_LEFT_ARROW, GraphicsType.CURVED_UP_ARROW, GraphicsType.CURVED_DOWN_ARROW, GraphicsType.MATH_DIVIDE, GraphicsType.MATH_NOT_EQUAL, GraphicsType.FLOW_CHART_DOCUMENT, GraphicsType.FLOW_CHART_MULTI_DOCUMENT, GraphicsType.FLOW_CHART_PUNCHED_TAPE, GraphicsType.FLOW_CHART_MAGNETIC_DISK, GraphicsType.FLOW_CHART_DISPLAY, GraphicsType.RIBBON, GraphicsType.RIBBON_2, GraphicsType.ELLIPSE_RIBBON, GraphicsType.ELLIPSE_RIBBON_2, GraphicsType.LEFT_RIGHT_RIBBON, GraphicsType.VERTICAL_SCROLL, GraphicsType.HORIZONTAL_SCROLL, GraphicsType.WAVE, GraphicsType.DOUBLE_WAVE, GraphicsType.WEDGE_RECT_CALLOUT, GraphicsType.WEDGE_ROUND_RECT_CALLOUT, GraphicsType.WEDGE_ELLIPSE_CALLOUT, GraphicsType.CLOUD_CALLOUT, GraphicsType.GEAR_6, GraphicsType.GEAR_9, GraphicsType.FUNNEL, GraphicsType.CORNER_TABS, GraphicsType.SQUARE_TABS, GraphicsType.PLAQUE_TABS, GraphicsType.CHART_X, GraphicsType.CHART_STAR, GraphicsType.CHART_PLUS, GraphicsType.CHEVRON, GraphicsType.PIE_WEDGE, GraphicsType.LEFT_ARROW_CALLOUT, GraphicsType.RIGHT_ARROW_CALLOUT, GraphicsType.UP_ARROW_CALLOUT, GraphicsType.DOWN_ARROW_CALLOUT, GraphicsType.LEFT_RIGHT_ARROW_CALLOUT, GraphicsType.UP_DOWN_ARROW_CALLOUT, GraphicsType.QUAD_ARROW_CALLOUT, GraphicsType.LINE_INV, GraphicsType.NON_ISOSCELES_TRAPEZOID, GraphicsType.SWOOSH_ARROW, GraphicsType.CIRCULAR_ARROW, GraphicsType.LEFT_CIRCULAR_ARROW, GraphicsType.LEFT_RIGHT_CIRCULAR_ARROW, GraphicsType.CUSTOM];
/**
 * path 中包含椭圆需要特殊处理的形状类型
 */
var EllipseType = [GraphicsType.FLOW_CHART_DELAY, GraphicsType.ELLIPSE, GraphicsType.PIE, GraphicsType.FLOW_CHART_CONNECTOR, GraphicsType.CHORD, GraphicsType.FLOW_CHART_SUMMING_JUNCTION, GraphicsType.FLOW_CHART_OR, GraphicsType.FLOW_CHART_MAGNETIC_TAPE];
/**
 * 不支持 webgl 时需要降级显示为矩形渐变的形状类型
 */
var ShapeToRectType = [GraphicsType.ROUND_RECT, GraphicsType.SNIP_ROUND_RECT, GraphicsType.ROUND_SAME_SIDE_RECT, GraphicsType.ROUND_SINGLE_RECT, GraphicsType.ROUND_DIAG_RECT, GraphicsType.FLOW_CHART_ALTERNATE_PROCESS, GraphicsType.CAN, GraphicsType.LEFT_BRACKET, GraphicsType.RIGHT_BRACKET];
/**
 * 不支持 webgl 时需要降级显示为径向渐变的形状类型
 */
var ShapeToRadialType = [GraphicsType.TEARDROP, GraphicsType.HEART, GraphicsType.CLOUD, GraphicsType.ARC, GraphicsType.BRACKET_PAIR, GraphicsType.FLOW_CHART_TERMINATOR, GraphicsType.FLOW_CHART_ONLINE_STORAGE, GraphicsType.FLOW_CHART_MAGNETIC_DRUM];
function isEllipseType(type) {
  return EllipseType.filter(function (item) {
    return item === type;
  }).length > 0;
}
function isRenderRectGradientType(type) {
  if (checkIsSupportWebgl()) {
    return RenderRectGradientType.filter(function (item) {
      return item === type;
    }).length > 0;
  }
  return [].concat(RenderRectGradientType, ShapeToRectType).filter(function (item) {
    return item === type;
  }).length > 0;
}
function isRenderRadialGradientType(type) {
  if (checkIsSupportWebgl()) {
    return RenderRadialGradientType.filter(function (item) {
      return item === type;
    }).length > 0;
  }
  return [].concat(RenderRadialGradientType, ShapeToRadialType).filter(function (item) {
    return item === type;
  }).length > 0;
}
var isSupportWebgl;
function checkIsSupportWebgl() {
  if (typeof isSupportWebgl !== 'undefined') {
    return isSupportWebgl;
  }
  var canvas = document.createElement('canvas');
  var gl = canvas.getContext('webgl');
  if (!gl) {
    isSupportWebgl = false;
    return isSupportWebgl;
  }
  isSupportWebgl = true;
  return isSupportWebgl;
}

function generateGradientColors(colorStops) {
  var gradient = [];
  var colors = [];
  colorStops.forEach(function (colorStop) {
    var offset = colorStop.offset,
      color = colorStop.color;
    var position = Number(offset) * 100;
    colors.push([position, color.red, color.green, color.blue, color.alpha]);
  });
  var firstColor = colors[0];
  if (firstColor[0] !== 0) {
    colors.unshift([0, firstColor[1], firstColor[2], firstColor[3], firstColor[4]]);
  }
  var lastColor = colors[colors.length - 1];
  if (lastColor[0] !== 100) {
    colors.push([100, lastColor[1], lastColor[2], lastColor[3], lastColor[4]]);
  }
  for (var i = 0; i <= 100; i++) {
    var color = interpolateColor(i, colors);
    gradient.push.apply(gradient, _toConsumableArray(color));
  }
  return gradient;
}
/**
 * 根据已知位置和颜色数组，插值计算 position 对应的颜色
 * @param position
 * @param colors
 */
function interpolateColor(position, colors) {
  // 找到最接近position的两个位置
  var i = 1;
  while (colors[i][0] < position) {
    i += 1;
  }
  var x1 = colors[i - 1][0];
  var x2 = colors[i][0];
  if (colors[i][1] === colors[i - 1][1] && colors[i][2] === colors[i - 1][2] && colors[i][3] === colors[i - 1][3] && colors[i][4] === colors[i - 1][4]) {
    return colors[i].slice(1);
  }
  // 计算position在x1和x2之间的位置比例
  var p = (position - x1) / (x2 - x1);
  // 对每个颜色通道进行线性插值
  var rgba = [];
  for (var j = 1; j < 5; j++) {
    var c1 = colors[i - 1][j];
    var c2 = colors[i][j];
    var ci = Math.round(c1 + p * (c2 - c1));
    rgba.push(ci);
  }
  // 返回计算得到的颜色值
  return rgba;
}

// 创建顶点着色器
var vertexShaderSource = "\n  attribute vec2 a_position;\n  attribute vec2 a_texCoord;\n  attribute vec2 a_canvasSize;\n  varying vec2 v_texCoord;\n  void main() {\n    // \u5C06 canvas \u7684\u5750\u6807\u503C \u8F6C\u6362\u4E3A [-1.0, 1.0]\u7684\u8303\u56F4\u3002\n    vec2 position = (a_position / a_canvasSize) * 2.0 - 1.0;\n    // canvas\u7684 Y \u8F74\u5750\u6807\u65B9\u5411\u548C\u8BBE\u5907\u5750\u6807\u7CFB\u7684\u76F8\u53CD\u3002\n    position = position * vec2(1.0, -1.0);\n    // \u6700\u7EC8\u7684\u9876\u70B9\u5750\u6807\u3002\n    gl_Position = vec4(position, 0.0, 1.0);\n    v_texCoord = a_texCoord;\n  }\n";
// 创建片段着色器
var fragmentShaderSource = "\n  precision mediump float;\n  uniform sampler2D u_texture;\n  varying vec2 v_texCoord;\n  void main() {\n    gl_FragColor = texture2D(u_texture, v_texCoord);\n  }\n";
function glGradientFill(glBuffer, options) {
  var gl = glBuffer.gl;
  var positions = options.positions,
    colorStops = options.colorStops,
    mode = options.mode,
    _options$width = options.width,
    width = _options$width === void 0 ? glBuffer.width : _options$width,
    _options$height = options.height,
    height = _options$height === void 0 ? glBuffer.height : _options$height;
  gl.clearColor(0, 0, 0, 0);
  gl.clear(gl.COLOR_BUFFER_BIT);
  var vertexShader = glBuffer.getShader('gradientVertex', gl.VERTEX_SHADER, vertexShaderSource);
  var fragmentShader = glBuffer.getShader('gradientFragment', gl.FRAGMENT_SHADER, fragmentShaderSource);
  var program = glBuffer.useProgram('gradient', vertexShader, fragmentShader);
  // 创建缓冲区并存储顶点数据
  var globalBuffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, globalBuffer);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
  // 启用顶点属性
  var positionAttributeLocation = gl.getAttribLocation(program, 'a_position');
  gl.enableVertexAttribArray(positionAttributeLocation);
  gl.vertexAttribPointer(positionAttributeLocation, 2, gl.FLOAT, false, 16, 0);
  var texCoordAttributeLocation = gl.getAttribLocation(program, 'a_texCoord');
  gl.enableVertexAttribArray(texCoordAttributeLocation);
  gl.vertexAttribPointer(texCoordAttributeLocation, 2, gl.FLOAT, false, 16, 8);
  var canvasSizeAttributeLocation = gl.getAttribLocation(program, 'a_canvasSize');
  gl.vertexAttrib2f(canvasSizeAttributeLocation, width, height);
  createTexture(gl, colorStops);
  // 绘制矩形
  gl.drawArrays(mode, 0, positions.length / 4);
}
/**
 * 根据颜色创建渐变纹理
 * @param gl
 * @param colorStops
 */
function createTexture(gl, colorStops) {
  // 创建纹理对象并存储渐变颜色
  var texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  var gradientColors = new Uint8Array(generateGradientColors(colorStops));
  // 设置纹理参数
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gradientColors.length / 4, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, gradientColors);
}

var WebglRenderServices = /*#__PURE__*/function () {
  function WebglRenderServices() {
    _classCallCheck(this, WebglRenderServices);
    this.cacheCapacity = 500;
    this.cachePool = new LruCache(this.cacheCapacity);
  }
  return _createClass(WebglRenderServices, [{
    key: "generateSource",
    value: function generateSource(buffer, options) {
      var key = this.generateKey(options);
      var texture = this.cachePool.get(key);
      if (texture) {
        return texture;
      }
      var width = options.width,
        height = options.height,
        mode = options.mode,
        positions = options.positions,
        colorStops = options.colorStops;
      glGradientFill(buffer, {
        width: width,
        height: height,
        mode: mode,
        positions: positions,
        colorStops: colorStops
      });
      var url = buffer["native"].toDataURL();
      var resource = imageCache.get({
        alloyParams: {
          urlOrImage: url
        }
      });
      this.cachePool.put(key, resource);
      return resource;
    }
  }, {
    key: "renderBuffer",
    value: function renderBuffer(buffer, options) {
      var width = options.width,
        height = options.height,
        mode = options.mode,
        positions = options.positions,
        colorStops = options.colorStops;
      glGradientFill(buffer, {
        width: width,
        height: height,
        mode: mode,
        positions: positions,
        colorStops: colorStops
      });
    }
  }, {
    key: "generateKey",
    value: function generateKey(options) {
      var _ref = options || {},
        originX = _ref.originX,
        originY = _ref.originY,
        gsList = _ref.gsList,
        tileRect = _ref.tileRect;
      return "".concat(originX, "_").concat(originY, "_").concat(JSON.stringify(gsList), "_").concat(JSON.stringify(tileRect));
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!WebglRenderServices.instance) {
        WebglRenderServices.instance = new WebglRenderServices();
      }
      return WebglRenderServices.instance;
    }
  }]);
}();

function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
var BaseShapeGradientFill = /*#__PURE__*/function (_CustomGradientFill) {
  function BaseShapeGradientFill(options) {
    var _this;
    _classCallCheck(this, BaseShapeGradientFill);
    _this = _callSuper$6(this, BaseShapeGradientFill);
    _this.initialWidth = options.width;
    _this.initialHeight = options.height;
    _this.originX = options.originX;
    _this.originY = options.originY;
    _this.gsList = options.gsList;
    _this.centerFrame = options.centerFrame;
    return _this;
  }
  _inherits(BaseShapeGradientFill, _CustomGradientFill);
  return _createClass(BaseShapeGradientFill, [{
    key: "getGradient",
    value: function getGradient() {
      return null;
    }
  }, {
    key: "renderWithClip",
    value: function renderWithClip(canvas, obj) {
      this.updateSize(obj);
      if (!checkIsSupportWebgl()) {
        this.renderWithCanvas2D(canvas, obj);
        return;
      }
      this.renderWidthWebgl(canvas, obj);
    }
  }, {
    key: "updateInitialSize",
    value: function updateInitialSize(width, height) {
      this.initialWidth = width;
      this.initialHeight = height;
    }
  }, {
    key: "updateSize",
    value: function updateSize(obj) {
      this.updateParentScale(obj);
      this.updatedCenterPoints();
      this.width = this.initialWidth * this.parentScale;
      this.height = this.initialHeight * this.parentScale;
    }
  }, {
    key: "updatedCenterPoints",
    value: function updatedCenterPoints() {
      var point = [this.originX * this.initialWidth * this.parentScale, this.originY * this.initialHeight * this.parentScale, 0, 0];
      this.center = [point];
    }
  }, {
    key: "updateParentScale",
    value: function updateParentScale(obj) {
      this.parentScale = 1;
      if (!checkIsSupportWebgl() || !obj) {
        return;
      }
      var parentObj = obj.parent;
      while (parentObj) {
        this.parentScale *= Math.abs(parentObj.scaleX);
        parentObj = parentObj.parent;
      }
    }
  }, {
    key: "renderWidthWebgl",
    value: function renderWidthWebgl(canvas, obj) {
      var _BrowserGlBuffer$getI = BrowserGlBuffer.getInstance(),
        width = _BrowserGlBuffer$getI.width,
        height = _BrowserGlBuffer$getI.height;
      var realWidth = this.width * canvas.resolution;
      var realHeight = this.height * canvas.resolution;
      // buffer 尺寸小于元素尺寸时，需要 resize 画布
      var resize = !(width >= realWidth && height >= realHeight);
      var bufferWidth = resize ? this.width : undefined;
      var bufferHeight = resize ? this.height : undefined;
      var buffer = canvas.getGlBuffer(bufferWidth, bufferHeight, canvas.resolution);
      if (!buffer) {
        return;
      }
      canvas.save();
      canvas.clip();
      this.applyTransformTo(canvas, obj.initialBounds);
      buffer.gl.viewport(0, 0, realWidth, realHeight);
      WebglRenderServices.getInstance().renderBuffer(buffer, {
        width: this.width,
        height: this.height,
        mode: this.centerFrame ? buffer.gl.TRIANGLES : buffer.gl.TRIANGLE_FAN,
        positions: this.getWebglPositions(obj.segments),
        colorStops: this.colorStops
      });
      canvas.drawCanvas(buffer, 0, 0, this.initialWidth, this.initialHeight, 0, Math.floor(buffer.height - realHeight), Math.floor(realWidth), Math.floor(realHeight));
      canvas.restore();
    }
  }, {
    key: "renderWithCanvas2D",
    value: function renderWithCanvas2D(canvas, obj) {
      var _a;
      canvas.save();
      canvas.clip();
      this.applyTransformTo(canvas, obj.initialBounds);
      this.renderGradient(canvas, obj.segments);
      canvas.restore();
      (_a = obj.applyFullPath) === null || _a === void 0 ? void 0 : _a.call(obj, canvas);
    }
  }]);
}(CustomGradientFill);

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, o, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), e, o); return 2 & r && "function" == typeof p ? function (t) { return p.apply(o, t); } : p; }
var domMatrix = typeof DOMMatrix !== 'undefined' ? new DOMMatrix() : undefined;
var RectGradientFill = /*#__PURE__*/function (_BaseShapeGradientFil) {
  function RectGradientFill(options, config) {
    var _this;
    _classCallCheck(this, RectGradientFill);
    var _a, _b, _c, _d;
    _this = _callSuper$5(this, RectGradientFill, [options]);
    _this.sourceTransform = new Transform();
    var _ref = config || {},
      tileRect = _ref.tileRect,
      _ref$useSelfTransform = _ref.useSelfTransform,
      useSelfTransform = _ref$useSelfTransform === void 0 ? false : _ref$useSelfTransform,
      _ref$useResource = _ref.useResource,
      useResource = _ref$useResource === void 0 ? false : _ref$useResource;
    _this.tileRect = {
      b: ((_a = tileRect === null || tileRect === void 0 ? void 0 : tileRect.b) !== null && _a !== void 0 ? _a : 0) / 100,
      l: ((_b = tileRect === null || tileRect === void 0 ? void 0 : tileRect.l) !== null && _b !== void 0 ? _b : 0) / 100,
      r: ((_c = tileRect === null || tileRect === void 0 ? void 0 : tileRect.r) !== null && _c !== void 0 ? _c : 0) / 100,
      t: ((_d = tileRect === null || tileRect === void 0 ? void 0 : tileRect.t) !== null && _d !== void 0 ? _d : 0) / 100
    };
    _this.useSelfTransform = useSelfTransform;
    _this.useResource = useResource;
    _this.transform._addUpdateListener(_this._updated);
    _this.sourceTransform._addUpdateListener(_this._updated);
    return _this;
  }
  _inherits(RectGradientFill, _BaseShapeGradientFil);
  return _createClass(RectGradientFill, [{
    key: "updatedCenterPoints",
    value: function updatedCenterPoints() {
      if (!this.centerFrame) {
        return _superPropGet(RectGradientFill, "updatedCenterPoints", this, 3)([]);
      }
      var _this$centerFrame = this.centerFrame,
        left = _this$centerFrame.left,
        top = _this$centerFrame.top,
        width = _this$centerFrame.width,
        height = _this$centerFrame.height;
      var point1 = [left * this.parentScale, top * this.parentScale, 0, 0];
      var point2 = [left * this.parentScale, (top + height) * this.parentScale, 0, 0];
      var point3 = [(left + width) * this.parentScale, (top + height) * this.parentScale, 0, 0];
      var point4 = [(left + width) * this.parentScale, top * this.parentScale, 0, 0];
      this.center = [point1, point2, point3, point4];
    }
  }, {
    key: "getTransform",
    value: function getTransform(canvas, bounds) {
      if (this.useSelfTransform) {
        return this.calculateBaseTransform(canvas, bounds);
      }
      return _superPropGet(RectGradientFill, "getTransform", this, 3)([canvas, bounds]);
    }
  }, {
    key: "getNative",
    value: function getNative(canvas, bounds) {
      var pattern = this.createPattern(canvas);
      if (Boolean(domMatrix && (pattern === null || pattern === void 0 ? void 0 : pattern.setTransform))) {
        var _this$calculateBaseTr = this.calculateBaseTransform(canvas, bounds),
          a = _this$calculateBaseTr.a,
          b = _this$calculateBaseTr.b,
          c = _this$calculateBaseTr.c,
          d = _this$calculateBaseTr.d,
          tx = _this$calculateBaseTr.tx,
          ty = _this$calculateBaseTr.ty;
        domMatrix.a = a;
        domMatrix.b = b;
        domMatrix.c = c;
        domMatrix.d = d;
        domMatrix.e = tx;
        domMatrix.f = ty;
        pattern.setTransform(domMatrix);
      }
      return pattern;
    }
  }, {
    key: "createPattern",
    value: function createPattern(canvas) {
      this.updateSize();
      if (checkIsSupportWebgl()) {
        return this.createPatternWithWebgl(canvas);
      }
      var buffer = canvas.createBuffer(this.width, this.height);
      this.renderGradient(buffer);
      return canvas.createPattern(buffer, 'no-repeat');
    }
  }, {
    key: "getWebglPositions",
    value: function getWebglPositions() {
      var positions = [];
      var vertices = this.centerFrame ? this.getVerticesWithTitle() : this.getShapeVertices();
      vertices.forEach(function (item) {
        positions.push.apply(positions, _toConsumableArray(item));
      });
      return positions;
    }
  }, {
    key: "renderGradient",
    value: function renderGradient(canvas) {
      if (this.centerFrame) {
        this.renderTetragonGradient(canvas);
        return;
      }
      this.renderTriangleGradient(canvas);
    }
  }, {
    key: "createPatternWithWebgl",
    value: function createPatternWithWebgl(canvas) {
      var buffer = canvas.getGlBuffer(this.width, this.height);
      if (!buffer) {
        return null;
      }
      var renderOptions = {
        width: this.width,
        height: this.height,
        mode: buffer.gl.TRIANGLE_FAN,
        positions: this.getWebglPositions(),
        colorStops: this.colorStops,
        callback: this._updated,
        originX: this.originX,
        originY: this.originY,
        tileRect: this.tileRect,
        gsList: this.gsList
      };
      if (this.useResource) {
        var resource = WebglRenderServices.getInstance().generateSource(buffer, renderOptions);
        if (resource && !resource.loading) {
          this.resourceWidth = resource.width;
          this.resourceHeight = resource.height;
          return canvas.createPattern(resource, 'no-repeat');
        }
        resource.onImageLoaded(this._updated);
        return null;
      }
      WebglRenderServices.getInstance().renderBuffer(buffer, renderOptions);
      return canvas.createPattern(buffer, 'no-repeat');
    }
  }, {
    key: "calculateBaseTransform",
    value: function calculateBaseTransform(canvas, bounds) {
      var _a, _b;
      var sx = bounds.width / ((_a = this.resourceWidth) !== null && _a !== void 0 ? _a : this.width * canvas.resolution);
      var sy = bounds.height / ((_b = this.resourceHeight) !== null && _b !== void 0 ? _b : this.height * canvas.resolution);
      return new Matrix().set(sx, 0, 0, sy, bounds.x, bounds.y).append(this.sourceTransform.matrix).prepend(this.transform.matrix);
    }
  }, {
    key: "getShapeVertices",
    value: function getShapeVertices() {
      var vertices = [];
      var _this$tileRect = this.tileRect,
        b = _this$tileRect.b,
        r = _this$tileRect.r,
        t = _this$tileRect.t,
        l = _this$tileRect.l;
      var bottom = b * this.height;
      var right = r * this.width;
      var left = l * this.width;
      var top = t * this.height;
      vertices.push(this.center[0], [left, top, 1, 0], [this.width - right, top, 1, 0], [this.width - right, this.height - bottom, 1, 0], [left, this.height - bottom, 1, 0], [left, top, 1, 0]);
      return vertices;
    }
  }, {
    key: "renderTriangleGradient",
    value: function renderTriangleGradient(canvas) {
      var _this2 = this;
      var rectVertices = this.getShapeVertices();
      var triangleArray = getTriangleVertices(rectVertices, 1 + 2 / this.width, 1 + 2 / this.height);
      triangleArray.forEach(function (vertices) {
        var points = getPerpendicularPoint(vertices);
        _this2.renderLinearGradient(canvas, vertices, points);
      });
    }
  }, {
    key: "renderTetragonGradient",
    value: function renderTetragonGradient(canvas) {
      var _this3 = this;
      canvas.nativeFillStyle = this.colorStops[0].color.rgba;
      var center = [];
      this.center.forEach(function (item) {
        center.push(item[0], item[1]);
      });
      this.applyPath(canvas, center);
      canvas.fill();
      var tetragonVertices = this.getTetragonVertices();
      var tetragonArray = [];
      tetragonVertices.forEach(function (vertices) {
        tetragonArray.push([vertices[0][0], vertices[0][1], vertices[1][0], vertices[1][1], vertices[2][0], vertices[2][1], vertices[3][0], vertices[3][1]]);
      });
      tetragonArray.forEach(function (vertices) {
        var points = getPerpendicularPoint(vertices.slice(2));
        _this3.renderLinearGradient(canvas, vertices, points);
      });
    }
  }, {
    key: "renderLinearGradient",
    value: function renderLinearGradient(canvas, vertices, points) {
      var _points = _slicedToArray(points, 2),
        start = _points[0],
        end = _points[1];
      var gradient = canvas.createLinearGradient(start.x, start.y, end.x, end.y);
      var _iterator = _createForOfIteratorHelper$1(this.colorStops),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var colorStop = _step.value;
          var offset = colorStop.offset,
            color = colorStop.color;
          gradient.addColorStop(offset, color.rgba);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      canvas.nativeFillStyle = gradient;
      this.applyPath(canvas, vertices);
    }
  }, {
    key: "applyPath",
    value: function applyPath(canvas, vertices) {
      canvas.beginPath();
      for (var i = 0; i < vertices.length; i += 2) {
        if (i === 0) {
          canvas.moveTo(vertices[i], vertices[i + 1]);
        } else {
          canvas.lineTo(vertices[i], vertices[i + 1]);
        }
      }
      canvas.closePath();
      canvas.fill();
    }
  }, {
    key: "getVerticesWithTitle",
    value: function getVerticesWithTitle() {
      var vertices = [];
      var tetragonVertices = this.getTetragonVertices();
      tetragonVertices.forEach(function (item) {
        vertices.push(item[0], item[1], item[2]);
        vertices.push(item[0], item[2], item[3]);
      });
      vertices.push(this.center[0], this.center[1], this.center[2]);
      vertices.push(this.center[0], this.center[2], this.center[3]);
      return vertices;
    }
  }, {
    key: "getTetragonVertices",
    value: function getTetragonVertices() {
      var rectVertices = [[0, 0, 1, 0], [0, this.height, 1, 0], [this.width, this.height, 1, 0], [this.width, 0, 1, 0]];
      var tetragonVertices = [[this.center[0], this.center[3], rectVertices[3], rectVertices[0]], [this.center[1], this.center[0], rectVertices[0], rectVertices[1]], [this.center[2], this.center[1], rectVertices[1], rectVertices[2]], [this.center[3], this.center[2], rectVertices[2], rectVertices[3]]];
      return tetragonVertices;
    }
  }]);
}(BaseShapeGradientFill);
__decorate([dep, __metadata("design:type", Object)], RectGradientFill.prototype, "tileRect", void 0);

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
var segmentType = {
  MoveTo: 'M',
  LineTo: 'L',
  CurveTo: 'C',
  QuadraticCurveTo: 'Q',
  ClosePath: 'Z'
};
var matrix = new Matrix();
var GradientType;
(function (GradientType) {
  GradientType[GradientType["Linear"] = 0] = "Linear";
  GradientType[GradientType["Radial"] = 1] = "Radial";
})(GradientType || (GradientType = {}));
var ShapeGradientFill = /*#__PURE__*/function (_BaseShapeGradientFil) {
  function ShapeGradientFill(options, isEllipseType) {
    var _this;
    _classCallCheck(this, ShapeGradientFill);
    _this = _callSuper$4(this, ShapeGradientFill, [options]);
    _this.isEllipseType = isEllipseType;
    return _this;
  }
  _inherits(ShapeGradientFill, _BaseShapeGradientFil);
  return _createClass(ShapeGradientFill, [{
    key: "getWebglPositions",
    value: function getWebglPositions(segments) {
      var positions = [];
      var vertices = this.getShapeVertices(segments);
      vertices.forEach(function (item) {
        positions.push.apply(positions, _toConsumableArray(item));
      });
      return positions;
    }
  }, {
    key: "renderGradient",
    value: function renderGradient(canvas, segments) {
      var _this2 = this;
      var rectVertices = this.getShapeVertices(segments);
      var triangleArray = getTriangleVertices(rectVertices, 1 + 2 / this.width, 1 + 2 / this.height);
      triangleArray.forEach(function (vertices, index) {
        _this2.renderTriangleGradient(canvas, vertices, segments[index + 1]);
      });
    }
  }, {
    key: "getShapeVertices",
    value: function getShapeVertices(segments) {
      var _this3 = this;
      var vertices = [];
      vertices.push(this.center[0]);
      segments.forEach(function (segment) {
        if (checkIsSupportWebgl() && _this3.isCurve(segment)) {
          var points = _this3.getPointsOnPath(segment);
          points.forEach(function (point) {
            vertices.push([].concat(_toConsumableArray(point), [1, 0]));
          });
        } else {
          vertices.push([segment.x * _this3.parentScale, segment.y * _this3.parentScale, 1, 0]);
        }
      });
      return vertices;
    }
  }, {
    key: "renderTriangleGradient",
    value: function renderTriangleGradient(canvas, vertices, segment) {
      var type = this.isEllipseType && this.isCurve(segment) ? GradientType.Radial : GradientType.Linear;
      canvas.nativeFillStyle = this.getFillGradient(canvas, {
        vertices: vertices,
        type: type
      });
      this.renderTrianglePath(canvas, vertices, segment);
      this.fill(canvas, type);
    }
  }, {
    key: "getPointsOnPath",
    value: function getPointsOnPath(segment) {
      var path;
      if (segment.cmd === segmentType.CurveTo) {
        path = "M ".concat(segment.startX * this.parentScale, " ").concat(segment.startY * this.parentScale, " ").concat(segment.cmd, " ").concat(segment.x1 * this.parentScale, " ").concat(segment.y1 * this.parentScale, ", ").concat(segment.x2 * this.parentScale, " ").concat(segment.y2 * this.parentScale, ", ").concat(segment.x * this.parentScale, " ").concat(segment.y * this.parentScale);
      } else {
        path = "M ".concat(segment.startX * this.parentScale, " ").concat(segment.startY * this.parentScale, " ").concat(segment.cmd, " ").concat(segment.x1 * this.parentScale, " ").concat(segment.y1 * this.parentScale, ", ").concat(segment.x * this.parentScale, " ").concat(segment.y * this.parentScale);
      }
      return pointsOnPath(path, 0.1, 0.1)[0].slice(1);
    }
  }, {
    key: "isCurve",
    value: function isCurve(segment) {
      return (segment === null || segment === void 0 ? void 0 : segment.cmd) === segmentType.CurveTo || (segment === null || segment === void 0 ? void 0 : segment.cmd) === segmentType.QuadraticCurveTo;
    }
  }, {
    key: "renderTrianglePath",
    value: function renderTrianglePath(canvas, triangle, segment) {
      var _triangle = _slicedToArray(triangle, 6),
        x1 = _triangle[0],
        y1 = _triangle[1],
        x2 = _triangle[2],
        y2 = _triangle[3],
        x3 = _triangle[4],
        y3 = _triangle[5];
      canvas.beginPath();
      canvas.moveTo(x1, y1);
      canvas.lineTo(x2, y2);
      if (this.isEllipseType) {
        switch (segment === null || segment === void 0 ? void 0 : segment.cmd) {
          case segmentType.LineTo:
          case segmentType.ClosePath:
            canvas.lineTo(x3, y3);
            break;
          case segmentType.CurveTo:
            canvas.bezierCurveTo(segment.x1, segment.y1, segment.x2, segment.y2, x3, y3);
            break;
          case segmentType.QuadraticCurveTo:
            canvas.quadraticCurveTo(segment.x1, segment.y1, x3, y3);
            break;
        }
      } else {
        canvas.lineTo(x3, y3);
      }
      canvas.closePath();
    }
  }, {
    key: "fill",
    value: function fill(canvas, type) {
      if (type === GradientType.Radial) {
        canvas.save();
        var transform = new Transform();
        var scaleX = this.width > this.height ? 1 : this.width / this.height;
        var scaleY = this.width > this.height ? this.height / this.width : 1;
        transform.scaleX = scaleX;
        transform.scaleY = scaleY;
        transform.pivotX = Math.floor(this.width / 2);
        transform.pivotY = Math.floor(this.height / 2);
        transform.translateX = Math.floor(this.width / 2);
        transform.translateY = Math.floor(this.height / 2);
        canvas.transform = matrix.copyFrom(canvas.transform).append(transform.matrix);
        canvas.fill();
        canvas.restore();
      } else {
        canvas.fill();
      }
    }
  }, {
    key: "getFillGradient",
    value: function getFillGradient(canvas, options) {
      var vertices = options.vertices,
        type = options.type;
      var _vertices = _slicedToArray(vertices, 2),
        x1 = _vertices[0],
        y1 = _vertices[1];
      var _getPerpendicularPoin = getPerpendicularPoint(vertices),
        _getPerpendicularPoin2 = _slicedToArray(_getPerpendicularPoin, 2),
        start = _getPerpendicularPoin2[0],
        end = _getPerpendicularPoin2[1];
      var gradient;
      if (type === GradientType.Radial) {
        var radius = Math.max(this.width, this.height) / 2;
        gradient = canvas.createRadialGradient(x1, y1, 0, x1, y1, radius);
      } else {
        gradient = canvas.createLinearGradient(start.x, start.y, end.x, end.y);
      }
      var _iterator = _createForOfIteratorHelper(this.colorStops),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var colorStop = _step.value;
          var offset = colorStop.offset,
            color = colorStop.color;
          gradient.addColorStop(offset, color.rgba);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return gradient;
    }
  }]);
}(BaseShapeGradientFill);

function cloneFrame(frame) {
  var offsetFrame = frame.offsetFrame;
  return Object.assign(Object.assign({}, frame), {
    offsetFrame: offsetFrame && Object.assign({}, offsetFrame)
  });
}

/**
 * 处理每个渐变光圈的位置和颜色
 * @param gradFill
 * @param fillMode
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getGsList(gradFill, fillMode) {
  return gradFill.gsList.map(function (item) {
    var bgColor = '#ffffff00';
    if (item === null || item === void 0 ? void 0 : item.color) {
      bgColor = item.color;
    }
    return {
      pos: item.pos / 100,
      color: getRenderColor(generateColorWithFillMode(bgColor, fillMode))
    };
  });
}
/**
 * 获取径向渐变圆心位置和结束圆半径大小
 * @param pathGradient
 * @param rotateWithShape
 * @param frame
 */
function getRadialCircle(pathGradient, rotateWithShape, frame) {
  var width = frame.width,
    height = frame.height;
  var val;
  var x;
  var y;
  if (!rotateWithShape) {
    // 不随形状旋转
    var direct = getConfigByRect(pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.fillToRect);
    var angle = direct.angle;
    if (angle) {
      // 不居中
      var point = angle2CirclePoint(angle);
      val = {
        cx: point.cx,
        cy: point.cy,
        r: 2
      };
    } else {
      // 居中
      val = direct.val;
    }
    var newFrame = getFrameAfterOffset(Object.assign(Object.assign({}, frame), {
      left: 0,
      top: 0
    }));
    width = newFrame.width;
    height = newFrame.height;
    x = newFrame.left + val.cx * width;
    y = newFrame.top + val.cy * height;
  } else {
    val = getConfigByRect(pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.fillToRect).val;
    x = val.cx * width;
    y = val.cy * height;
  }
  var r = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) / 2;
  return {
    x: x,
    y: y,
    radius: val.r * r
  };
}
function getFrameAfterScale(options) {
  var textConfig = options.textConfig,
    frame = options.frame,
    _options$scaleX = options.scaleX,
    scaleX = _options$scaleX === void 0 ? 1 : _options$scaleX,
    _options$scaleY = options.scaleY,
    scaleY = _options$scaleY === void 0 ? 1 : _options$scaleY;
  var newFrame = cloneFrame(options.frame);
  newFrame.width = frame.width / scaleX;
  newFrame.height = frame.height / scaleY;
  if (textConfig === null || textConfig === void 0 ? void 0 : textConfig.needRotate) {
    // 竖排需要旋转情况，对调宽高
    newFrame.width = frame.height;
    newFrame.height = frame.width;
  }
  return newFrame;
}
function getConfigByRect(fillToRect) {
  if (fillToRect) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < DIRECT_LIST.length; i++) {
      var item = DIRECT_LIST[i];
      if (item.rect.b === fillToRect.b && item.rect.l === fillToRect.l && item.rect.r === fillToRect.r && item.rect.t === fillToRect.t) {
        return item;
      }
    }
  }
  return DIRECT_LIST[0];
}
var DIRECT_LIST = [{
  id: 'center',
  rect: {
    b: 50,
    l: 50,
    r: 50,
    t: 50
  },
  val: {
    cx: 0.5,
    cy: 0.5,
    r: 1
  }
}, {
  id: 'leftTop',
  rect: {
    b: 100,
    l: 0,
    r: 100,
    t: 0
  },
  val: {
    cx: 0,
    cy: 0,
    r: 2
  },
  angle: 225,
  position: '0% 0%'
}, {
  id: 'rightTop',
  rect: {
    b: 100,
    l: 100,
    r: 0,
    t: 0
  },
  val: {
    cx: 1,
    cy: 0,
    r: 2
  },
  angle: 315,
  position: '100% 0%'
}, {
  id: 'leftBottom',
  rect: {
    b: 0,
    l: 0,
    r: 100,
    t: 100
  },
  val: {
    cx: 0,
    cy: 1,
    r: 2
  },
  angle: 135,
  position: '0% 100%'
}, {
  id: 'rightBottom',
  rect: {
    b: 0,
    l: 100,
    r: 0,
    t: 100
  },
  val: {
    cx: 1,
    cy: 1,
    r: 2
  },
  angle: 45,
  position: '100% 100%'
}, {
  id: 'bottomTop',
  rect: {
    b: -30,
    l: 50,
    r: 50,
    t: 130
  },
  val: {
    cx: 0.5,
    cy: 1.3,
    r: 1.5
  },
  angle: 90
}, {
  id: 'topBottom',
  rect: {
    b: 180,
    l: 50,
    r: 50,
    t: -80
  },
  val: {
    cx: 0.5,
    cy: -0.3,
    r: 1.5
  },
  angle: 270
}];
/**
 * 角度转换为放射渐变的圆心坐标
 */
function angle2CirclePoint(angle) {
  var w = 1 / 2;
  var h = 1 / 2;
  var r = 0.7071;
  var radian = angle * Math.PI / 180; // 弧度
  var x = Math.cos(radian) * r + w;
  var y = Math.sin(radian) * r + h;
  return {
    cx: x.toFixed(2),
    cy: y.toFixed(2)
  };
}

var GradFill = /*#__PURE__*/function () {
  function GradFill() {
    _classCallCheck(this, GradFill);
  }
  return _createClass(GradFill, null, [{
    key: "setGradFillStyle",
    value: function setGradFillStyle(svgGraphics, gradFill, config) {
      if (!gradFill) {
        return;
      }
      svgGraphics.fill = this.getGradFill(gradFill, config);
    }
  }, {
    key: "getGradFill",
    value: function getGradFill(gradFill, config) {
      var pathGradient = gradFill.pathGradient;
      var gradient;
      if ((pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.path) === GradientType$1.Linear) {
        gradient = GradFill.getLinearGradient(gradFill, config);
      } else if ((pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.path) === GradientType$1.Rect) {
        gradient = GradFill.getRectGradient(gradFill, config);
      } else if ((pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.path) === GradientType$1.Shape) {
        gradient = GradFill.getShapeGradient(gradFill, config);
      } else {
        // 其他渐变暂时按径向渐变处理
        gradient = GradFill.getRadialGradient(gradFill, config);
      }
      var gsList = getGsList(gradFill, config.fillMode);
      GradFill.addColorStop(gradient, gsList);
      // 当元素有旋转/翻转时，需要对不跟随形状旋转的场景做逆向补偿
      if (!gradFill.rotateWithShape && !((pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.path) === GradientType$1.Rect || (pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.path) === GradientType$1.Shape)) {
        modifyTransform(gradient, config.frame);
      }
      return gradient;
    }
  }, {
    key: "addColorStop",
    value: function addColorStop(gradient, gsList) {
      if (!gradient) {
        return;
      }
      // pos 从小到大排序
      var list = gsList.map(function (item) {
        return [item.color, item.pos];
      }).sort(function (a, b) {
        return a[1] - b[1];
      });
      list.forEach(function (item) {
        var _item = _slicedToArray(item, 2),
          color = _item[0],
          pos = _item[1];
        gradient.addColorStop(pos, color);
      });
    }
  }, {
    key: "getLinearGradient",
    value: function getLinearGradient(gradFill, config) {
      var _a, _b;
      // 线性渐变
      var lin = gradFill.lin,
        rotateWithShape = gradFill.rotateWithShape;
      var frame = getFrameAfterScale(config);
      var angle = (_a = lin === null || lin === void 0 ? void 0 : lin.ang) !== null && _a !== void 0 ? _a : 0;
      angle = ((_b = config.textConfig) === null || _b === void 0 ? void 0 : _b.needRotate) ? angle + 90 : angle;
      var rect = angleToVector(angle, frame, rotateWithShape);
      var _this$getPointOffset = this.getPointOffset(config),
        offsetX = _this$getPointOffset.offsetX,
        offsetY = _this$getPointOffset.offsetY;
      return new RawLinearGradientFill(rect.x1 + offsetX, rect.y1 + offsetY, rect.x2 + offsetX, rect.y2 + offsetY);
    }
  }, {
    key: "getRadialGradient",
    value: function getRadialGradient(gradFill, config) {
      var pathGradient = gradFill.pathGradient,
        rotateWithShape = gradFill.rotateWithShape;
      var frame = getFrameAfterScale(config);
      var _getRadialCircle = getRadialCircle(pathGradient, rotateWithShape, frame),
        x = _getRadialCircle.x,
        y = _getRadialCircle.y,
        radius = _getRadialCircle.radius;
      var _this$getPointOffset2 = this.getPointOffset(config),
        offsetX = _this$getPointOffset2.offsetX,
        offsetY = _this$getPointOffset2.offsetY;
      return new RawRadialGradientFill(x + offsetX, y + offsetY, 0, x + offsetX, y + offsetY, radius);
    }
  }, {
    key: "getRectGradient",
    value: function getRectGradient(gradFill, config) {
      if (config.textConfig) {
        return GradFill.getTextRectGradient(gradFill, config);
      }
      return GradFill.getGraphicsRectGradient(gradFill, config);
    }
    // 文字矩形渐变
  }, {
    key: "getTextRectGradient",
    value: function getTextRectGradient(gradFill, config) {
      var _config$textConfig = config.textConfig,
        offsetX = _config$textConfig.offsetX,
        offsetY = _config$textConfig.offsetY,
        textWidth = _config$textConfig.textWidth,
        textHeight = _config$textConfig.textHeight,
        needRotate = _config$textConfig.needRotate,
        rectYOffset = _config$textConfig.rectYOffset,
        _config$textConfig$st = _config$textConfig.strokeWidth,
        strokeWidth = _config$textConfig$st === void 0 ? 0 : _config$textConfig$st;
      // 根据该行文字整体宽高和图片宽高的比例缩放图片
      var _config$frame = config.frame,
        width = _config$frame.width,
        height = _config$frame.height;
      var scaleX = (width + strokeWidth) / textWidth;
      var scaleY = (height + strokeWidth) / textHeight;
      var pathGradient = gradFill.pathGradient,
        tileRect = gradFill.tileRect;
      var _ref = (pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.fillToRect) || {},
        _ref$l = _ref.l,
        l = _ref$l === void 0 ? 50 : _ref$l,
        _ref$t = _ref.t,
        t = _ref$t === void 0 ? 50 : _ref$t;
      var fill = new RectGradientFill({
        width: textWidth,
        height: textHeight,
        originX: l / 100,
        originY: t / 100,
        gsList: gradFill.gsList
      }, {
        tileRect: tileRect,
        useSelfTransform: true,
        useResource: UserAgent.isChrome || UserAgent.isChromiumEdge || UserAgent.isTencentDocDesktopApp || UserAgent.isWindowWxMiniProgram || UserAgent.isAndroid || UserAgent.isQQBrowser
      });
      var transform = fill.transform,
        sourceTransform = fill.sourceTransform;
      if (needRotate) {
        // 竖排中文情况填充旋转90度，旋转后对 transform 位移进行校正
        transform.translateX = -offsetY + strokeWidth / 2;
        transform.translateY = offsetX + rectYOffset - strokeWidth / 2;
        transform.rotation = Math.PI / 2;
        sourceTransform.scaleX = scaleX;
        sourceTransform.scaleY = scaleY;
      } else {
        transform.translateX = offsetX - strokeWidth / 2;
        transform.translateY = -strokeWidth / 2;
        sourceTransform.scaleX = scaleX;
        sourceTransform.scaleY = 1 + strokeWidth / height;
      }
      return fill;
    }
    // 形状矩形渐变
  }, {
    key: "getGraphicsRectGradient",
    value: function getGraphicsRectGradient(gradFill, config) {
      var pathGradient = gradFill.pathGradient,
        rotateWithShape = gradFill.rotateWithShape,
        tileRect = gradFill.tileRect,
        centerFrame = gradFill.centerFrame;
      var _ref2 = (pathGradient === null || pathGradient === void 0 ? void 0 : pathGradient.fillToRect) || {},
        _ref2$l = _ref2.l,
        l = _ref2$l === void 0 ? 50 : _ref2$l,
        _ref2$t = _ref2.t,
        t = _ref2$t === void 0 ? 50 : _ref2$t;
      var _config$scaleX = config.scaleX,
        scaleX = _config$scaleX === void 0 ? 1 : _config$scaleX,
        _config$scaleY = config.scaleY,
        scaleY = _config$scaleY === void 0 ? 1 : _config$scaleY;
      var gsList = getGsList(gradFill, config.fillMode);
      var fill = new RectGradientFill({
        width: config.frame.width,
        height: config.frame.height,
        originX: l / 100,
        originY: t / 100,
        centerFrame: centerFrame,
        gsList: gsList
      }, {
        tileRect: tileRect,
        useSelfTransform: false
      });
      if (config.isStroke) {
        return fill;
      }
      if (!rotateWithShape && GradFill.shouldUpdateTransform(config.frame)) {
        var _getFrameAfterOffset = getFrameAfterOffset(config.frame),
          left = _getFrameAfterOffset.left,
          top = _getFrameAfterOffset.top,
          width = _getFrameAfterOffset.width,
          height = _getFrameAfterOffset.height;
        updateTransformMatrix(fill, Object.assign(Object.assign({}, config.frame), {
          scaleX: width / config.frame.width,
          scaleY: height / config.frame.height,
          translateX: left,
          translateY: top,
          pathScaleX: scaleX,
          pathScaleY: scaleY
        }));
      } else {
        var frame = getFrameAfterOffset(Object.assign(Object.assign({}, config.frame), {
          rotate: 0
        }));
        updateFillTransform(fill, {
          scaleX: frame.width / config.frame.width / scaleX,
          scaleY: frame.height / config.frame.height / scaleY,
          realWidth: frame.width,
          realHeight: frame.height
        });
      }
      return fill;
    }
  }, {
    key: "shouldUpdateTransform",
    value: function shouldUpdateTransform(frame) {
      var flipH = frame.flipH,
        flipV = frame.flipV,
        offsetFrame = frame.offsetFrame,
        _frame$rotate = frame.rotate,
        rotate = _frame$rotate === void 0 ? 0 : _frame$rotate;
      return flipH || flipV || rotate || offsetFrame;
    }
  }, {
    key: "getShapeGradient",
    value: function getShapeGradient(gradFill, config) {
      var _a;
      if (config.textConfig) {
        return GradFill.getTextRectGradient(gradFill, config);
      }
      if (config.isStroke) {
        return GradFill.getRadialGradient(gradFill, config);
      }
      var type = config.type;
      if (isRenderRectGradientType(type) || gradFill.centerFrame) {
        return GradFill.getRectGradient(Object.assign(Object.assign({}, gradFill), {
          rotateWithShape: true
        }), config);
      }
      if (isRenderRadialGradientType(type)) {
        return GradFill.getRadialGradient(Object.assign(Object.assign({}, gradFill), {
          rotateWithShape: true
        }), config);
      }
      var _ref3 = ((_a = gradFill.pathGradient) === null || _a === void 0 ? void 0 : _a.fillToRect) || {},
        _ref3$l = _ref3.l,
        l = _ref3$l === void 0 ? 50 : _ref3$l,
        _ref3$t = _ref3.t,
        t = _ref3$t === void 0 ? 50 : _ref3$t;
      return new ShapeGradientFill({
        width: config.frame.width,
        height: config.frame.height,
        originX: l / 100,
        originY: t / 100
      }, isEllipseType(type));
    }
  }, {
    key: "getPointOffset",
    value: function getPointOffset(config) {
      var _ref4 = config.textConfig || {},
        _ref4$offsetX = _ref4.offsetX,
        offsetX = _ref4$offsetX === void 0 ? 0 : _ref4$offsetX,
        _ref4$offsetY = _ref4.offsetY,
        offsetY = _ref4$offsetY === void 0 ? 0 : _ref4$offsetY,
        _ref4$rectYOffset = _ref4.rectYOffset,
        rectYOffset = _ref4$rectYOffset === void 0 ? 0 : _ref4$rectYOffset,
        _ref4$rectXOffset = _ref4.rectXOffset,
        rectXOffset = _ref4$rectXOffset === void 0 ? 0 : _ref4$rectXOffset,
        needRotate = _ref4.needRotate;
      return {
        offsetX: needRotate ? offsetY : offsetX + rectXOffset,
        offsetY: needRotate ? offsetX : offsetY + rectYOffset
      };
    }
  }]);
}();

var MAX_SIZE = 1200;
/**
 * 压缩图片质量
 */
var CompressedImageQuality = /*#__PURE__*/function () {
  function CompressedImageQuality() {
    _classCallCheck(this, CompressedImageQuality);
    this.cacheCapacity = 200;
    this.cachePool = new LruCache(this.cacheCapacity);
    this.buffer = new BrowserCanvas();
    this.buffer.width = MAX_SIZE;
    this.buffer.height = MAX_SIZE;
    this.buffer.resolution = 1;
  }
  return _createClass(CompressedImageQuality, [{
    key: "generateResource",
    value: function generateResource(src, image) {
      var texture = this.cachePool.get(src);
      if (texture) {
        return texture;
      }
      var compressedWidth;
      var compressedHeight;
      var width = image.width,
        height = image.height;
      if (width > height) {
        compressedWidth = MAX_SIZE;
        compressedHeight = Math.round(height * MAX_SIZE / width);
      } else {
        compressedHeight = MAX_SIZE;
        compressedWidth = Math.round(width * MAX_SIZE / height);
      }
      this.buffer.width = compressedWidth;
      this.buffer.height = compressedHeight;
      this.buffer.drawImage(image, 0, 0, compressedWidth, compressedHeight);
      var url = this.buffer["native"].toDataURL('image/jpeg');
      var resource = imageCache.get({
        alloyParams: {
          urlOrImage: url
        }
      });
      this.cachePool.put(src, resource);
      return resource;
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!CompressedImageQuality.instance) {
        CompressedImageQuality.instance = new CompressedImageQuality();
      }
      return CompressedImageQuality.instance;
    }
  }]);
}();

var ImageFill = /*#__PURE__*/function () {
  function ImageFill() {
    _classCallCheck(this, ImageFill);
  }
  return _createClass(ImageFill, null, [{
    key: "setImageFillStyle",
    value: function setImageFillStyle(svgGraphics, fill, config) {
      var src = fill.src,
        alpha = fill.alpha,
        gifFrameResource = fill.gifFrameResource;
      if (gifFrameResource) {
        ImageFill.setGifFillStyle(svgGraphics, fill, gifFrameResource, config);
        return;
      }
      var image = imageCache.get({
        alloyParams: {
          urlOrImage: src
        },
        customParams: {
          svgGraphics: svgGraphics,
          alpha: alpha
        }
      });
      var graphics = svgGraphics;
      image.onImageLoaded(function () {
        if (!config.compressedQuality) {
          ImageFill.setImageFill(graphics, fill, config, image);
          return;
        }
        var width = image.width,
          height = image.height;
        if (width > MAX_SIZE || height > MAX_SIZE) {
          var resource = CompressedImageQuality.getInstance().generateResource(src, image);
          resource.onImageLoaded(function () {
            ImageFill.setImageFill(graphics, fill, config, resource);
          });
        } else {
          ImageFill.setImageFill(graphics, fill, config, image);
        }
      });
    }
  }, {
    key: "setGifFillStyle",
    value: function setGifFillStyle(svgGraphics, fill, image, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var alpha, imageResource, imageFill;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              alpha = fill.alpha;
              imageResource = new ImageResource(image);
              imageResource.width = image.codedWidth;
              imageResource.height = image.codedHeight;
              if (config.textConfig) {
                // 文本填充
                imageFill = ImageFill.getTextImageFill(imageResource, config);
              } else {
                imageFill = ImageFill.getShapeImageFill(fill, imageResource, config, svgGraphics);
              }
              imageFill.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
              svgGraphics.fill = imageFill;
              svgGraphics.isPartRefreshObject = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "setImageFill",
    value: function setImageFill(svgGraphics, fill, config, image) {
      var alpha = fill.alpha;
      var imageFill;
      if (config.textConfig) {
        // 文本填充
        imageFill = ImageFill.getTextImageFill(image, config);
      } else {
        imageFill = ImageFill.getShapeImageFill(fill, image, config, svgGraphics);
      }
      imageFill.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
      // eslint-disable-next-line no-param-reassign
      svgGraphics.fill = imageFill;
      return imageFill;
    }
  }, {
    key: "getShapeImageFill",
    value: function getShapeImageFill(fill, image, config, graphics) {
      var _a, _b;
      var bgOptions = ImageFill.getBgOptions(config, image);
      var imageFill;
      var _getImageFrame = getImageFrame(fill, bgOptions),
        left = _getImageFrame.left,
        top = _getImageFrame.top,
        width = _getImageFrame.width,
        height = _getImageFrame.height,
        _getImageFrame$rotate = _getImageFrame.rotate,
        rotate = _getImageFrame$rotate === void 0 ? 0 : _getImageFrame$rotate;
      var scaleX = width / graphics.width;
      var scaleY = height / graphics.height;
      // 图片旋转角度为0包含两种情况：1. 图片跟随形状旋转；2. 图片为图片元素前景图
      var notRotate = rotate === 0;
      if (notRotate) {
        imageFill = new ImageFill$1(image);
        var configScaleX = (_a = config.scaleX) !== null && _a !== void 0 ? _a : 1;
        var configScaleY = (_b = config.scaleY) !== null && _b !== void 0 ? _b : 1;
        var originX = bgOptions.width / 2 / configScaleX;
        var originY = bgOptions.height / 2 / configScaleY;
        var finalLeft = left / configScaleX - graphics.initialBounds.x;
        var finalTop = top / configScaleY - graphics.initialBounds.y;
        imageFill.transform.translateX = originX + finalLeft;
        imageFill.transform.translateY = originY + finalTop;
        imageFill.imageTransform.scaleX = scaleX * (!fill.rotateWithShape && config.frame.flipH ? -1 : 1);
        imageFill.imageTransform.scaleY = scaleY * (!fill.rotateWithShape && config.frame.flipV ? -1 : 1);
        imageFill.transform.pivotX = originX;
        imageFill.transform.pivotY = originY;
        imageFill.transform.rotation = 0;
      } else {
        var _config$scaleX = config.scaleX,
          _scaleX = _config$scaleX === void 0 ? 1 : _config$scaleX,
          _config$scaleY = config.scaleY,
          _scaleY = _config$scaleY === void 0 ? 1 : _config$scaleY;
        var frame = Object.assign(Object.assign({}, config.frame), {
          scaleX: width / image.width,
          scaleY: height / image.height,
          translateX: left,
          translateY: top,
          pathScaleX: _scaleX,
          pathScaleY: _scaleY
        });
        imageFill = new RawImageFill(image);
        updateTransformMatrix(imageFill, frame);
      }
      return imageFill;
    }
    /**
     * 更新文字图片填充位置
     * @private
     */
  }, {
    key: "getTextImageFill",
    value: function getTextImageFill(image, config) {
      var _config$textConfig = config.textConfig,
        offsetX = _config$textConfig.offsetX,
        offsetY = _config$textConfig.offsetY,
        textWidth = _config$textConfig.textWidth,
        textHeight = _config$textConfig.textHeight,
        needRotate = _config$textConfig.needRotate,
        rectYOffset = _config$textConfig.rectYOffset;
      var imageFill = new ImageFill$1(image);
      // 根据该行文字整体宽高和图片宽高的比例缩放图片
      var _config$frame = config.frame,
        width = _config$frame.width,
        height = _config$frame.height;
      var scaleX = width / textWidth;
      var scaleY = height / textHeight;
      if (needRotate) {
        // 竖排中文情况填充旋转90度，旋转后对 transform 位移进行校正
        imageFill.transform.translateX = -offsetY;
        imageFill.transform.translateY = offsetX + rectYOffset;
        imageFill.imageTransform.scaleX = scaleX;
        imageFill.imageTransform.scaleY = scaleY;
        imageFill.transform.rotation = Math.PI / 2;
      } else {
        imageFill.transform.translateX = offsetX;
        imageFill.transform.translateY = 0;
        imageFill.imageTransform.scaleX = scaleX;
        imageFill.imageTransform.scaleY = 1;
      }
      return imageFill;
    }
  }, {
    key: "getBgOptions",
    value: function getBgOptions(config, image) {
      var _a, _b;
      return Object.assign(Object.assign({}, config.frame), {
        scaleW: (_a = config.scaleX) !== null && _a !== void 0 ? _a : 1,
        scaleH: (_b = config.scaleY) !== null && _b !== void 0 ? _b : 1,
        imgW: image.width || 0,
        imgH: image.height || 0
      });
    }
  }]);
}();

// 查看是否支持Webgl并开启了硬件加速
function checkIfChromeAccelerated() {
  var _a, _b;
  var canvas = document.createElement('canvas');
  var gl = canvas.getContext('webgl');
  if (!gl) {
    return false;
  }
  var accelerated = false;
  var debugInfo = (_a = gl.getExtension) === null || _a === void 0 ? void 0 : _a.call(gl, 'WEBGL_debug_renderer_info');
  if (debugInfo) {
    var renderer = (_b = gl.getParameter) === null || _b === void 0 ? void 0 : _b.call(gl, debugInfo.UNMASKED_RENDERER_WEBGL);
    accelerated = (renderer === null || renderer === void 0 ? void 0 : renderer.indexOf('SwiftShader')) === -1;
  }
  return accelerated;
}
function getChromeMajorVersion() {
  var userAgent = window.navigator.userAgent;
  var reg = new RegExp('Chrome/(\\d+\\.)+\\d+', 'i');
  var result = reg.exec(userAgent);
  if (!(result === null || result === void 0 ? void 0 : result[0])) {
    return 0;
  }
  var _result = _slicedToArray(result, 1),
    version = _result[0];
  return Number(version.split('/')[1].split('.')[0]);
}
var ChromeVersion = getChromeMajorVersion();

var TileImageFill = /*#__PURE__*/function () {
  function TileImageFill() {
    _classCallCheck(this, TileImageFill);
  }
  return _createClass(TileImageFill, null, [{
    key: "setImageFillStyle",
    value: function setImageFillStyle(svgGraphics, fill, config) {
      var _a, _b;
      // 当刻度为0时，渲染为无填充
      if (((_a = fill.tile) === null || _a === void 0 ? void 0 : _a.sx) === 0 || ((_b = fill.tile) === null || _b === void 0 ? void 0 : _b.sy) === 0) {
        svgGraphics.fill = Fill.None;
        return;
      }
      var src = fill.src,
        alpha = fill.alpha,
        gifFrameResource = fill.gifFrameResource;
      if (gifFrameResource) {
        TileImageFill.setGifFillStyle(svgGraphics, fill, gifFrameResource, config);
        return;
      }
      var image = imageCache.get({
        alloyParams: {
          urlOrImage: src
        },
        customParams: {
          svgGraphics: svgGraphics,
          alpha: alpha
        }
      });
      var graphics = svgGraphics;
      image.onImageLoaded(function () {
        if (!config.compressedQuality) {
          TileImageFill.setImageFill(graphics, fill, config, image);
          return;
        }
        var width = image.width,
          height = image.height;
        if (width > MAX_SIZE || height > MAX_SIZE) {
          var resource = CompressedImageQuality.getInstance().generateResource(src, image);
          resource.onImageLoaded(function () {
            TileImageFill.setImageFill(graphics, fill, config, resource);
          });
        } else {
          TileImageFill.setImageFill(graphics, fill, config, image);
        }
      });
    }
  }, {
    key: "setGifFillStyle",
    value: function setGifFillStyle(svgGraphics, fill, image, config) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var alpha, imageResource, imageFill;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              alpha = fill.alpha;
              imageResource = new ImageResource(image);
              imageResource.width = image.codedWidth;
              imageResource.height = image.codedHeight;
              if (config.textConfig) {
                // 文本填充
                imageFill = TileImageFill.getTextImageFill(config, imageResource, fill);
              } else {
                imageFill = TileImageFill.getShapeImageFill(imageResource, svgGraphics, fill, config);
              }
              imageFill.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
              svgGraphics.fill = imageFill;
              svgGraphics.isPartRefreshObject = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    }
  }, {
    key: "getShapeImageFill",
    value: function getShapeImageFill(image, graphics, fill, config) {
      var repeat = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : TilingRepeat.Both;
      var _a, _b;
      var tile = fill.tile;
      var useResource = UserAgent.isChrome || UserAgent.isFirefox || UserAgent.isTencentDocDesktopApp;
      var imageFill = new TilingImageFill(image, repeat, tile.flip, useResource);
      // 这两个语句是为了重置 TilingImageFill 内部的变换, 让变换完全由 transform 手动控制
      imageFill.imageTransform.translateX = -graphics.initialBounds.x;
      imageFill.imageTransform.translateY = -graphics.initialBounds.y;
      var frame = TileImageFill.getFillPosition(config, image, fill);
      if (!fill.rotateWithShape) {
        var left = frame.left,
          top = frame.top;
        updateTransformMatrix(imageFill, Object.assign(Object.assign({}, frame), {
          rotate: config.frame.rotate,
          flipH: config.frame.flipH,
          flipV: config.frame.flipV,
          translateX: left,
          translateY: top,
          scaleX: frame.scaleX * ((_a = config.scaleX) !== null && _a !== void 0 ? _a : 1),
          scaleY: frame.scaleY * ((_b = config.scaleY) !== null && _b !== void 0 ? _b : 1),
          pathScaleX: config.scaleX,
          pathScaleY: config.scaleY,
          offsetFrame: config.frame.offsetFrame
        }));
      } else {
        updateFillTransform(imageFill, frame);
      }
      return imageFill;
    }
  }, {
    key: "setImageFill",
    value: function setImageFill(graphics, fill, config, image) {
      var src = fill.src,
        alpha = fill.alpha;
      var imageFill;
      if (config.textConfig) {
        imageFill = TileImageFill.getTextImageFill(config, image, fill);
      } else {
        imageFill = TileImageFill.getShapeImageFill(image, graphics, fill, config);
      }
      if (/\.svg/i.test(src)) {
        // 现网 svg 大小是客户端大小的 2/3，放大图片和客户端保持一致
        imageFill.imageTransform.scaleX = 3 / 2;
        imageFill.imageTransform.scaleY = 3 / 2;
      }
      imageFill.alpha = alpha !== null && alpha !== void 0 ? alpha : 1;
      // eslint-disable-next-line no-param-reassign
      graphics.fill = imageFill;
    }
    /**
     * 更新文字图片填充位置
     * @private
     */
  }, {
    key: "getTextImageFill",
    value: function getTextImageFill(config, image, fill) {
      var tile = fill.tile;
      var flip = tile.flip;
      if (this.isNotSupportFlip()) {
        // Chrome 开启硬件加速并且文字图片平铺设置镜像类型后，文字不显示
        // 兜底方案：镜像类型都显示为"无镜像"
        flip = TilingMirror.None;
      }
      var useResource = UserAgent.isChrome || UserAgent.isFirefox || UserAgent.isTencentDocDesktopApp || UserAgent.isWindowWxMiniProgram || UserAgent.isAndroid;
      var imageFill = new TilingImageFill(image, TilingRepeat.Both, flip, useResource);
      var _TileImageFill$getFil = TileImageFill.getFillPosition(config, image, fill),
        left = _TileImageFill$getFil.left,
        top = _TileImageFill$getFil.top,
        scaleX = _TileImageFill$getFil.scaleX,
        scaleY = _TileImageFill$getFil.scaleY;
      var _ref = config.textConfig || {},
        _ref$offsetX = _ref.offsetX,
        offsetX = _ref$offsetX === void 0 ? 0 : _ref$offsetX,
        _ref$offsetY = _ref.offsetY,
        offsetY = _ref$offsetY === void 0 ? 0 : _ref$offsetY,
        _ref$rectYOffset = _ref.rectYOffset,
        rectYOffset = _ref$rectYOffset === void 0 ? 0 : _ref$rectYOffset,
        needRotate = _ref.needRotate;
      imageFill.imageTransform.scaleX = scaleX;
      imageFill.imageTransform.scaleY = scaleY;
      if (needRotate) {
        imageFill.transform.translateX = top - offsetY;
        imageFill.transform.translateY = left + offsetX + rectYOffset;
      } else {
        imageFill.transform.translateX = left + offsetX;
        imageFill.transform.translateY = top;
      }
      var rotate = needRotate ? 90 : 0;
      imageFill.transform.rotation = rotate * Math.PI / 180;
      return imageFill;
    }
  }, {
    key: "isNotSupportFlip",
    value: function isNotSupportFlip() {
      return UserAgent.isChrome && checkIfChromeAccelerated() && this.isChromeNotSupportTileImageFill() || UserAgent.isAndroid || UserAgent.isWindowWxMiniProgram;
    }
    /**
     * 判断当前 chrome 版本是否不支持图片平铺镜像
     * @returns
     */
  }, {
    key: "isChromeNotSupportTileImageFill",
    value: function isChromeNotSupportTileImageFill() {
      // 测试发现 windows chrome 103 版本之后不支持图片平铺镜像，目前最新版是 111，仍然不支持
      // 最新的 chrome 也不支持
      return ChromeVersion >= 103;
    }
  }, {
    key: "getFillPosition",
    value: function getFillPosition(config, image, fill) {
      var _a, _b, _c, _d;
      // Todo 图片填充比例
      var imageScale = config.textConfig ? 2 : 1;
      var _fill$tile = fill.tile,
        sx = _fill$tile.sx,
        sy = _fill$tile.sy;
      var imageScaleX = sx / 100 * imageScale;
      var imageScaleY = sy / 100 * imageScale;
      var bgOptions = Object.assign(Object.assign({}, config.frame), {
        scaleW: (_a = config.scaleX) !== null && _a !== void 0 ? _a : 1,
        scaleH: (_b = config.scaleY) !== null && _b !== void 0 ? _b : 1,
        imgW: image.width || 0,
        imgH: image.height || 0,
        imageScaleX: imageScaleX,
        imageScaleY: imageScaleY
      });
      var _ref2 = config.textConfig || {},
        needRotate = _ref2.needRotate;
      if (needRotate) {
        var tempWidth = bgOptions.width;
        bgOptions.width = bgOptions.height;
        bgOptions.height = tempWidth;
      }
      var _getTileImageFrame = getTileImageFrame(fill, bgOptions),
        left = _getTileImageFrame.left,
        top = _getTileImageFrame.top,
        width = _getTileImageFrame.width,
        height = _getTileImageFrame.height,
        rotate = _getTileImageFrame.rotate;
      var scaleX = width / bgOptions.imgW;
      var scaleY = height / bgOptions.imgH;
      var realWidth = config.frame.width / ((_c = config.scaleX) !== null && _c !== void 0 ? _c : 1);
      var realHeight = config.frame.height / ((_d = config.scaleY) !== null && _d !== void 0 ? _d : 1);
      return {
        left: left,
        top: top,
        rotate: rotate,
        scaleX: scaleX,
        scaleY: scaleY,
        realWidth: realWidth,
        realHeight: realHeight,
        width: realWidth,
        height: realHeight
      };
    }
  }]);
}();

function setFillStyle(svgGraphics, fillStyle, config) {
  if (!fillStyle) {
    return;
  }
  setNoFillStyle(svgGraphics, fillStyle.noFill);
  setSolidFillStyle(svgGraphics, fillStyle.solidFill, config);
  PatternFill.setPatternFillStyle(svgGraphics, fillStyle.patternFill, config);
  GradFill.setGradFillStyle(svgGraphics, fillStyle.gradFill, config);
  setImageFillStyle(svgGraphics, fillStyle, config);
}
function setNoFillStyle(svgGraphics, noFill) {
  if (!noFill) {
    return;
  }
  svgGraphics.fill = Fill.None;
}
function setSolidFillStyle(svgGraphics, solidFill, config) {
  if (!solidFill) {
    return;
  }
  var color = generateColorWithFillMode(solidFill.color, config.fillMode);
  var renderColor = getRenderColor(color);
  if (!renderColor) {
    return;
  }
  svgGraphics.fill = new ColorFill(renderColor);
}
function setImageFillStyle(svgGraphics, fillStyle, config) {
  if (!fillStyle.imageFill) {
    return;
  }
  if (fillStyle.imageFill.tile) {
    TileImageFill.setImageFillStyle(svgGraphics, fillStyle.imageFill, config);
  } else {
    ImageFill.setImageFillStyle(svgGraphics, fillStyle.imageFill, config);
  }
}

var ImageFilterDefaultValues = {
  ClARITY: 0,
  BRIGHTNESS: 0,
  CONTRAST: 0,
  SATURATE: 100,
  TEMPERATURE: 6500
};
var DEFAULT_SCALE = 1;
var DEFAULT_BLUR_SCALE = 2;
var DEFAULT_DISTANCE_SCALE = 2;
/**
 * PPT 单位磅转为 px，基本是 1 : 1.333
 * @param {number} pt
 * @returns {number}
 */
var PX_IN_ONE_INCH = 96;
var PT_IN_ONE_INCH = 72;
var PT_TO_REAL_PX_RATE = PX_IN_ONE_INCH / PT_IN_ONE_INCH;

var ImageFilter = /*#__PURE__*/function () {
  function ImageFilter() {
    _classCallCheck(this, ImageFilter);
  }
  return _createClass(ImageFilter, null, [{
    key: "shouldForbidWebglForColorFilter",
    value: function shouldForbidWebglForColorFilter(forbidWebgl, imageFilter) {
      var biLevel = imageFilter.biLevel,
        luminance = imageFilter.luminance,
        duotone = imageFilter.duotone;
      // 统一渲染层使用 filter 渲染图片效果时将 svg 属性设置为 'display: none'，导致 Firefox 无法渲染效果
      // 但是不使用 'display: none' 隐藏 svg 标签时 filter 渲染效果和 webgl 渲染效果不同，Firefox 先强制使用 webgl 渲染图片效果
      if (biLevel || duotone || luminance || UserAgent.isFirefox) {
        return false;
      }
      return forbidWebgl;
    }
  }]);
}();
ImageFilter.generateImageFilter = function (imageFilter, forbidWebgl) {
  var brightness = imageFilter.brightness,
    colorTemperature = imageFilter.colorTemperature,
    contrast = imageFilter.contrast,
    saturate = imageFilter.saturate,
    sharpenSoften = imageFilter.sharpenSoften,
    grayscl = imageFilter.grayscl,
    biLevel = imageFilter.biLevel,
    duotone = imageFilter.duotone,
    luminance = imageFilter.luminance;
  var colorAdjustmentFilterParams = {
    brightness: ImageFilter.getBrightnessValue(brightness),
    contrast: ImageFilter.getContrastValue(contrast),
    saturate: ImageFilter.getSaturateValue(saturate),
    temperature: colorTemperature,
    grayscl: grayscl,
    biLevel: biLevel
  };
  if (duotone) {
    colorAdjustmentFilterParams.duotone = {
      color1: Color.fromHex(duotone.clr1.srgb_color || ''),
      color2: Color.fromHex(duotone.clr2.srgb_color || '')
    };
  }
  if (luminance) {
    colorAdjustmentFilterParams.luminance = {
      brightness: ImageFilter.getBrightnessValue(luminance.brightness),
      contrast: ImageFilter.getContrastValue(luminance.contrast)
    };
  }
  var colorAdjustmentFilter = new ColorAdjustmentFilter(colorAdjustmentFilterParams);
  colorAdjustmentFilter.forbidWebgl = ImageFilter.shouldForbidWebglForColorFilter(forbidWebgl, imageFilter);
  var filters = [colorAdjustmentFilter];
  if (sharpenSoften > 0) {
    var sharpenFilter = new SharpenFilter({
      size: sharpenSoften / 100
    });
    sharpenFilter.forbidWebgl = forbidWebgl;
    filters.push(sharpenFilter);
  } else if (sharpenSoften < 0) {
    var radius = -sharpenSoften / 10 * 4;
    var blurFilter = new BlurFilter({
      radiusX: radius,
      radiusY: radius,
      maxPadX: 0,
      maxPadY: 0
    });
    blurFilter.forbidWebgl = forbidWebgl;
    filters.push(blurFilter);
  }
  return filters;
};
/**
 * 是否对 image 增加滤镜
 * 所有属性为默认值时不添加滤镜
 */
ImageFilter.isShowImageFilter = function (image) {
  if (!image) return false;
  var sharpenSoften = image.sharpenSoften,
    contrast = image.contrast,
    colorTemperature = image.colorTemperature,
    brightness = image.brightness,
    saturate = image.saturate,
    grayscl = image.grayscl,
    biLevel = image.biLevel,
    duotone = image.duotone,
    luminance = image.luminance;
  return sharpenSoften !== ImageFilterDefaultValues.ClARITY || contrast !== ImageFilterDefaultValues.CONTRAST || colorTemperature !== ImageFilterDefaultValues.TEMPERATURE || brightness !== ImageFilterDefaultValues.BRIGHTNESS || saturate !== ImageFilterDefaultValues.SATURATE || grayscl || !!biLevel || biLevel === 0 || !!duotone || !!luminance;
};
// 计算亮度值
ImageFilter.getBrightnessValue = function (val) {
  if (!val) return 1;
  if (val < 0) return val / 100 + 1;
  return val !== 100 ? 1 / (1 - val / 100) : 100;
};
// 计算对比度的值
ImageFilter.getContrastValue = function (val) {
  var value = val / 100;
  return value < 0 ? value + 1 : 1 + value / 0.6;
};
// 计算饱和度值
ImageFilter.getSaturateValue = function () {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  return val / 100;
};

var DisplayRule;
(function (DisplayRule) {
  /** 不显示效果 */
  DisplayRule[DisplayRule["None"] = 0] = "None";
  /** 文本显示效果 */
  DisplayRule[DisplayRule["Text"] = 1] = "Text";
  /** 形状显示效果 */
  DisplayRule[DisplayRule["Shape"] = 2] = "Shape";
  /** 两者都显示效果 */
  DisplayRule[DisplayRule["Both"] = 3] = "Both";
})(DisplayRule || (DisplayRule = {}));
var DisplayScene;
(function (DisplayScene) {
  DisplayScene["Text"] = "Text";
  DisplayScene["Shape"] = "Shape";
})(DisplayScene || (DisplayScene = {}));
var DefaultDisplayOptions = {
  shadow: DisplayRule.Both,
  glow: DisplayRule.Both,
  softEdge: DisplayRule.Both,
  reflection: DisplayRule.Both,
  image: DisplayRule.Both
};
function isShowFilter(rule, scene) {
  var isShow = false;
  if (rule === DisplayRule.Both) {
    isShow = true;
  } else if (rule === DisplayRule.Text && scene === DisplayScene.Text) {
    isShow = true;
  } else if (rule === DisplayRule.Shape && scene === DisplayScene.Shape) {
    isShow = true;
  }
  return isShow;
}

var BaseFilter = /*#__PURE__*/function () {
  function BaseFilter() {
    _classCallCheck(this, BaseFilter);
  }
  return _createClass(BaseFilter, [{
    key: "scene",
    get: function get() {
      return this.textConfig ? DisplayScene.Text : DisplayScene.Shape;
    }
  }, {
    key: "display",
    get: function get() {
      return isShowFilter(this.rule, this.scene);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "isFilterShow",
    value: function isFilterShow(effect) {
      return this.display;
    }
  }]);
}();

var FilterTransformOriginCalculator = /*#__PURE__*/function () {
  function FilterTransformOriginCalculator() {
    var _this = this;
    _classCallCheck(this, FilterTransformOriginCalculator);
    this.transformOriginMap = {
      tl: function tl() {
        return {
          originX: 0,
          originY: 0
        };
      },
      t: function t() {
        return {
          originX: 0.5,
          originY: 0
        };
      },
      tr: function tr() {
        return {
          originX: 1,
          originY: 0
        };
      },
      l: function l() {
        return {
          originX: 0,
          originY: 0.5
        };
      },
      ctr: function ctr() {
        return {
          originX: 0.5,
          originY: 0.5
        };
      },
      r: function r() {
        return {
          originX: 1,
          originY: 0.5
        };
      },
      bl: function bl() {
        return {
          originX: 0,
          originY: 1
        };
      },
      b: function b() {
        return {
          originX: 0.5,
          originY: 1
        };
      },
      br: function br() {
        return {
          originX: 1,
          originY: 1
        };
      }
    };
    this.textTransformOriginMap = {
      tl: function tl() {
        return {
          originX: _this.getInlineStart(),
          originY: 0
        };
      },
      t: function t() {
        return {
          originX: _this.getInlineCenter(),
          originY: 0
        };
      },
      tr: function tr() {
        return {
          originX: _this.getInlineEnd(),
          originY: 0
        };
      },
      l: function l() {
        return {
          originX: _this.getInlineStart(),
          originY: 0.5
        };
      },
      ctr: function ctr() {
        return {
          originX: _this.getInlineCenter(),
          originY: 0.5
        };
      },
      r: function r() {
        return {
          originX: _this.getInlineEnd(),
          originY: 0.5
        };
      },
      bl: function bl() {
        return {
          originX: _this.getInlineStart(),
          originY: 1
        };
      },
      b: function b() {
        return {
          originX: _this.getInlineCenter(),
          originY: 1
        };
      },
      br: function br() {
        return {
          originX: _this.getInlineEnd(),
          originY: 1
        };
      }
    };
    this.vertTextTransformOriginMap = {
      tl: function tl() {
        return {
          originX: 1,
          originY: _this.getInlineStart()
        };
      },
      t: function t() {
        return {
          originX: 1,
          originY: _this.getInlineCenter()
        };
      },
      tr: function tr() {
        return {
          originX: 1,
          originY: _this.getInlineEnd()
        };
      },
      l: function l() {
        return {
          originX: 0.5,
          originY: _this.getInlineStart()
        };
      },
      ctr: function ctr() {
        return {
          originX: 0.5,
          originY: _this.getInlineCenter()
        };
      },
      r: function r() {
        return {
          originX: 0.5,
          originY: _this.getInlineEnd()
        };
      },
      bl: function bl() {
        return {
          originX: 0,
          originY: _this.getInlineStart()
        };
      },
      b: function b() {
        return {
          originX: 0,
          originY: _this.getInlineCenter()
        };
      },
      br: function br() {
        return {
          originX: 0,
          originY: _this.getInlineEnd()
        };
      }
    };
  }
  return _createClass(FilterTransformOriginCalculator, [{
    key: "getTransformOrigin",
    value: function getTransformOrigin(algn) {
      if (this.characterOffset) {
        // 文本
        if (this.vertical) {
          return this.vertTextTransformOriginMap[algn];
        }
        return this.textTransformOriginMap[algn];
      }
      // 形状
      return this.transformOriginMap[algn];
    }
  }, {
    key: "run",
    value: function run(algn, characterOffset, vertical) {
      this.characterOffset = characterOffset;
      this.vertical = vertical;
      var calculator = this.getTransformOrigin(algn);
      if (!calculator) {
        return null;
      }
      return calculator();
    }
  }, {
    key: "getInlineStart",
    value: function getInlineStart() {
      if (!this.characterOffset) {
        return 0;
      }
      var _this$characterOffset = this.characterOffset,
        offsetStart = _this$characterOffset.offsetStart,
        offsetSize = _this$characterOffset.offsetSize;
      return -offsetStart / offsetSize;
    }
  }, {
    key: "getInlineCenter",
    value: function getInlineCenter() {
      if (!this.characterOffset) {
        return 0.5;
      }
      var _this$characterOffset2 = this.characterOffset,
        offsetStart = _this$characterOffset2.offsetStart,
        offsetEnd = _this$characterOffset2.offsetEnd,
        offsetSize = _this$characterOffset2.offsetSize;
      return ((offsetStart + offsetEnd + offsetSize) / 2 - offsetStart) / offsetSize;
    }
  }, {
    key: "getInlineEnd",
    value: function getInlineEnd() {
      if (!this.characterOffset) {
        return 1;
      }
      var _this$characterOffset3 = this.characterOffset,
        offsetEnd = _this$characterOffset3.offsetEnd,
        offsetSize = _this$characterOffset3.offsetSize;
      return (offsetEnd + offsetSize) / offsetSize;
    }
  }]);
}();
var filterTransformOriginCalculator = new FilterTransformOriginCalculator();

/**
 * 对齐方式
 */
var Algn;
(function (Algn) {
  /**
   * 左上
   */
  Algn["TL"] = "tl";
  /**
   * 上
   */
  Algn["T"] = "t";
  /**
   * 右上
   */
  Algn["TR"] = "tr";
  /**
   * 左
   */
  Algn["L"] = "l";
  /**
   * 中
   */
  Algn["CTR"] = "ctr";
  /**
   * 右
   */
  Algn["R"] = "r";
  /**
   * 左下
   */
  Algn["BL"] = "bl";
  /**
   * 下
   */
  Algn["B"] = "b";
  /**
   * 右下
   */
  Algn["BR"] = "br";
})(Algn || (Algn = {}));

function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
var ShadowFilter = /*#__PURE__*/function (_BaseFilter) {
  function ShadowFilter() {
    _classCallCheck(this, ShadowFilter);
    return _callSuper$3(this, ShadowFilter, arguments);
  }
  _inherits(ShadowFilter, _BaseFilter);
  return _createClass(ShadowFilter, [{
    key: "generateParams",
    value: function generateParams(shadow, rule, config) {
      this.textConfig = config;
      this.rule = rule;
      if (!shadow || !this.isFilterShow(shadow)) {
        return;
      }
      var color = shadow.color,
        _shadow$opacity = shadow.opacity,
        opacity = _shadow$opacity === void 0 ? 0 : _shadow$opacity,
        _shadow$size = shadow.size,
        size = _shadow$size === void 0 ? 0 : _shadow$size,
        _shadow$blur = shadow.blur,
        blur = _shadow$blur === void 0 ? 0 : _shadow$blur,
        _shadow$angle = shadow.angle,
        angle = _shadow$angle === void 0 ? 0 : _shadow$angle,
        _shadow$distance = shadow.distance,
        distance = _shadow$distance === void 0 ? 0 : _shadow$distance,
        isOuter = shadow.isOuter,
        _shadow$skewX = shadow.skewX,
        skewX = _shadow$skewX === void 0 ? 0 : _shadow$skewX,
        _shadow$skewY = shadow.skewY,
        skewY = _shadow$skewY === void 0 ? 0 : _shadow$skewY,
        _shadow$scaleX = shadow.scaleX,
        scaleX = _shadow$scaleX === void 0 ? 0 : _shadow$scaleX,
        _shadow$scaleY = shadow.scaleY,
        scaleY = _shadow$scaleY === void 0 ? 0 : _shadow$scaleY,
        algn = shadow.algn;
      var alpha = opacityToAlpha(opacity);
      var rgba = hexToRgba(color, alpha);
      var _this$getTransformOri = this.getTransformOrigin(algn),
        originX = _this$getTransformOri.originX,
        originY = _this$getTransformOri.originY;
      var scale = this.getScale(size, scaleX, scaleY);
      var skew = this.getSkew(skewX, skewY);
      var renderAngle = (config === null || config === void 0 ? void 0 : config.needRotate) ? angle + 90 : angle;
      var renderColor = getRenderColor(rgba);
      if (!renderColor) {
        return;
      }
      return {
        blur: blur * this.getBlurScale(Math.max(scale[0], scale[1])),
        angle: renderAngle,
        distance: distance * this.getDistanceScale(),
        scaleX: scale[0],
        scaleY: scale[1],
        inner: isOuter === false,
        color: renderColor,
        skewAngleX: skew[0],
        skewAngleY: skew[1],
        originX: originX,
        originY: originY
      };
    }
  }, {
    key: "isFilterShow",
    value: function isFilterShow(shadow) {
      return shadow && (shadow === null || shadow === void 0 ? void 0 : shadow.size) !== 0 && opacityToAlpha(shadow === null || shadow === void 0 ? void 0 : shadow.opacity) !== 0 && this.display;
    }
  }, {
    key: "getScale",
    value: function getScale(size, sizeX, sizeY) {
      var _a;
      var scaleX = (sizeX || size) / 100;
      var scaleY = (sizeY || size) / 100;
      if ((_a = this.textConfig) === null || _a === void 0 ? void 0 : _a.needRotate) {
        var _reverse = [scaleX, scaleY].reverse();
        var _reverse2 = _slicedToArray(_reverse, 2);
        scaleX = _reverse2[0];
        scaleY = _reverse2[1];
      }
      return [scaleX, scaleY];
    }
  }, {
    key: "getSkew",
    value: function getSkew(skewX, skewY) {
      var _a;
      if ((_a = this.textConfig) === null || _a === void 0 ? void 0 : _a.isVertical) {
        var _reverse3 = [-skewX, skewY].reverse();
        var _reverse4 = _slicedToArray(_reverse3, 2);
        skewX = _reverse4[0];
        skewY = _reverse4[1];
      }
      return [skewX, skewY];
    }
  }, {
    key: "getTransformOrigin",
    value: function getTransformOrigin(algn) {
      if (this.textConfig) {
        var _this$textConfig = this.textConfig,
          characterOffset = _this$textConfig.characterOffset,
          needRotate = _this$textConfig.needRotate;
        return filterTransformOriginCalculator.run(algn || Algn.B, characterOffset, needRotate);
      }
      return filterTransformOriginCalculator.run(algn || Algn.CTR);
    }
    // 测试发现 ppt 中阴影大小随文字大小变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
  }, {
    key: "getBlurScale",
    value: function getBlurScale(scaleX) {
      if (!this.textConfig) {
        return DEFAULT_BLUR_SCALE;
      }
      var fontSize = this.textConfig.fontSize;
      return (fontSize ? 0.0078 * fontSize + 0.1173 : 1) / scaleX;
    }
    // 测试发现 ppt 中阴影偏移量随文字大小变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
  }, {
    key: "getDistanceScale",
    value: function getDistanceScale() {
      if (!this.textConfig) {
        return DEFAULT_DISTANCE_SCALE;
      }
      var fontSize = this.textConfig.fontSize;
      return fontSize ? fontSize * 0.0236 + 0.3034 : PT_TO_REAL_PX_RATE;
    }
  }]);
}(BaseFilter);
var shadowFilter = new ShadowFilter();

function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
var GlowFilter = /*#__PURE__*/function (_BaseFilter) {
  function GlowFilter() {
    _classCallCheck(this, GlowFilter);
    return _callSuper$2(this, GlowFilter, arguments);
  }
  _inherits(GlowFilter, _BaseFilter);
  return _createClass(GlowFilter, [{
    key: "generateParams",
    value: function generateParams(glow, rule, config) {
      this.textConfig = config;
      this.rule = rule;
      if (!glow || !this.isFilterShow(glow)) {
        return;
      }
      var color = glow.color,
        _glow$opacity = glow.opacity,
        opacity = _glow$opacity === void 0 ? 0 : _glow$opacity,
        _glow$size = glow.size,
        size = _glow$size === void 0 ? 0 : _glow$size;
      var alpha = opacityToAlpha(opacity);
      var rgba = hexToRgba(color, alpha);
      var renderColor = getRenderColor(rgba);
      if (!renderColor) {
        return;
      }
      return {
        size: size * this.getSizeScale(),
        color: renderColor
      };
    }
  }, {
    key: "isFilterShow",
    value: function isFilterShow(glow) {
      return glow && (glow === null || glow === void 0 ? void 0 : glow.size) !== 0 && opacityToAlpha(glow === null || glow === void 0 ? void 0 : glow.opacity) !== 0 && this.display;
    }
  }, {
    key: "getSizeScale",
    value: function getSizeScale() {
      if (!this.textConfig) {
        return DEFAULT_SCALE;
      }
      var fontSize = this.textConfig.fontSize;
      // 测试发现 ppt 中阴影大小随文字大小变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
      return fontSize ? 0.0286 * fontSize + 0.1434 : PT_TO_REAL_PX_RATE;
    }
  }]);
}(BaseFilter);
var glowFilter = new GlowFilter();

function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var ReflectionFilter = /*#__PURE__*/function (_BaseFilter) {
  function ReflectionFilter() {
    _classCallCheck(this, ReflectionFilter);
    return _callSuper$1(this, ReflectionFilter, arguments);
  }
  _inherits(ReflectionFilter, _BaseFilter);
  return _createClass(ReflectionFilter, [{
    key: "generateParams",
    value: function generateParams(reflection, rule, config) {
      this.textConfig = config;
      this.rule = rule;
      if (!reflection || !this.isFilterShow(reflection)) {
        return;
      }
      var _reflection$blur = reflection.blur,
        blur = _reflection$blur === void 0 ? 0 : _reflection$blur,
        _reflection$distance = reflection.distance,
        distance = _reflection$distance === void 0 ? 0 : _reflection$distance,
        _reflection$size = reflection.size,
        size = _reflection$size === void 0 ? 0 : _reflection$size,
        _reflection$endOpacit = reflection.endOpacity,
        endOpacity = _reflection$endOpacit === void 0 ? 99.6 : _reflection$endOpacit,
        _reflection$startOpac = reflection.startOpacity,
        startOpacity = _reflection$startOpac === void 0 ? 0 : _reflection$startOpac,
        rotateWithShape = reflection.rotateWithShape;
      var opacityScale = this.getOpacityScale(distance);
      var sizeScale = this.getSizeScale(distance, size);
      var compensationValue = this.getCompensationValue();
      return {
        blur: blur * this.getBlurScale(),
        distance: distance * this.getDistScale() + compensationValue,
        height: size / 100 * sizeScale,
        gradientEndAlpha: opacityToAlpha(endOpacity) * opacityScale,
        gradientBeginAlpha: opacityToAlpha(startOpacity) * opacityScale * sizeScale,
        rotateWithElement: config ? true : rotateWithShape,
        direction: (config === null || config === void 0 ? void 0 : config.needRotate) ? Direction.HORIZONTAL : Direction.VERTICAL,
        flip: !!(config === null || config === void 0 ? void 0 : config.needRotate)
      };
    }
  }, {
    key: "isFilterShow",
    value: function isFilterShow(reflection) {
      return reflection && (reflection === null || reflection === void 0 ? void 0 : reflection.size) !== 0 && opacityToAlpha(reflection === null || reflection === void 0 ? void 0 : reflection.startOpacity) !== 0 && this.display;
    }
  }, {
    key: "getSizeScale",
    value: function getSizeScale(dist, size) {
      if (size === 100) {
        return DEFAULT_SCALE;
      }
      return -0.0062 * dist + 0.9843;
    }
    /**
     * 获取映像距离的补偿值
     * office ppt 中映像是基于当前行文字基线做翻转，但是目前渲染层是基于 RectText 边缘做翻转，所以要计算二者的位置差异补偿回去
     * @returns
     */
  }, {
    key: "getCompensationValue",
    value: function getCompensationValue() {
      if (!this.textConfig) {
        return 0;
      }
      // 获取当前行基线距离行底部的位置
      var baselinePosition = this.textConfig.getLineBaselinePosition();
      // 当前文字底部距离行底部的位置
      var offsetToLineBottom = this.textConfig.offsetToLineBottom;
      // 补偿值为什么这么计算，详见 https://iwiki.woa.com/pages/viewpage.action?pageId=4007296669
      return (offsetToLineBottom - baselinePosition) * 2;
    }
    // 测试发现 ppt 中阴影大小随文字大小变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
  }, {
    key: "getBlurScale",
    value: function getBlurScale() {
      if (!this.textConfig) {
        return DEFAULT_BLUR_SCALE;
      }
      var fontSize = this.textConfig.fontSize;
      return fontSize ? 0.0073 * fontSize + 0.0486 : 1;
    }
    // 测试发现 ppt 中映像透明度随映像距离变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
  }, {
    key: "getOpacityScale",
    value: function getOpacityScale(dist) {
      if (!this.textConfig) {
        return DEFAULT_SCALE;
      }
      var scale = -(0.007 * dist) + 0.95;
      // 保证不会出现负值
      return Math.max(scale, 0);
    }
    // 测试发现 ppt 中映像偏移量随文字大小变化，但是没找到具体的规则，这个函数是根据不同大小文字的最近似的数据拟合得到
  }, {
    key: "getDistScale",
    value: function getDistScale() {
      if (!this.textConfig) {
        return DEFAULT_DISTANCE_SCALE;
      }
      var fontSize = this.textConfig.fontSize;
      return fontSize ? 0.1318 * fontSize + 0.0182 : PT_TO_REAL_PX_RATE;
    }
  }]);
}(BaseFilter);
var reflectionFilter = new ReflectionFilter();

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SoftEdgeFilter = /*#__PURE__*/function (_BaseFilter) {
  function SoftEdgeFilter() {
    _classCallCheck(this, SoftEdgeFilter);
    return _callSuper(this, SoftEdgeFilter, arguments);
  }
  _inherits(SoftEdgeFilter, _BaseFilter);
  return _createClass(SoftEdgeFilter, [{
    key: "generateParams",
    value: function generateParams(softEdge, rule, config) {
      var _a;
      this.textConfig = config;
      this.rule = rule;
      if (!softEdge || !this.isFilterShow()) {
        return;
      }
      return {
        size: (_a = softEdge.size) !== null && _a !== void 0 ? _a : 0,
        isPicture: false
      };
    }
  }]);
}(BaseFilter);
var softEdgeFilter = new SoftEdgeFilter();

/**
 * 根据 UIModel effect 数据生成 filter 需要的数据
 * @param effect
 * @param filterDisplayOptions
 * @param config
 */
function generateFilterParams(effect, filterDisplayOptions, config) {
  if (!effect) {
    return effect;
  }
  return {
    shadow: shadowFilter.generateParams(effect.shadow || null, filterDisplayOptions.shadow, config),
    glow: glowFilter.generateParams(effect.glow || null, filterDisplayOptions.glow, config),
    reflection: reflectionFilter.generateParams(effect.reflection || null, filterDisplayOptions.reflection, config),
    softEdge: softEdgeFilter.generateParams(effect.softEdge || null, filterDisplayOptions.softEdge, config)
  };
}

var FILTER_SCALE = 1.75;
var WEBGL_SCALE = 1.25;
function generateEffectFilters(effect, effectOptions) {
  var _effectOptions$filter = effectOptions.filterDisplayOptions,
    filterDisplayOptions = _effectOptions$filter === void 0 ? DefaultDisplayOptions : _effectOptions$filter,
    forbidWebgl = effectOptions.forbidWebgl,
    isPicture = effectOptions.isPicture,
    textConfig = effectOptions.textConfig;
  var effectParams = generateFilterParams(effect, filterDisplayOptions, textConfig);
  var _ref = effectParams || {},
    shadow = _ref.shadow,
    glow = _ref.glow,
    reflection = _ref.reflection,
    softEdge = _ref.softEdge;
  var filters = [];
  if (shadow === null || shadow === void 0 ? void 0 : shadow.inner) {
    var shadowFilter = new ShadowFilter$1(shadow);
    shadowFilter.forbidWebgl = forbidWebgl;
    filters.push(shadowFilter);
  }
  if (softEdge) {
    // 柔化边缘不同实现方式效果不同，添加系数保证柔化到元素消失时的数值差不多
    softEdge.size = forbidWebgl ? softEdge.size * FILTER_SCALE : softEdge.size * WEBGL_SCALE;
    var softEdgeFilter = new SoftEdgeFilter$1(Object.assign(Object.assign({}, softEdge), {
      isPicture: isPicture
    }));
    softEdgeFilter.forbidWebgl = forbidWebgl;
    filters.push(softEdgeFilter);
  }
  if (glow) {
    var glowFilter = new GlowFilter$1(glow);
    glowFilter.forbidWebgl = forbidWebgl;
    filters.push(glowFilter);
  }
  if (shadow && !(shadow === null || shadow === void 0 ? void 0 : shadow.inner)) {
    var _shadowFilter = new ShadowFilter$1(shadow);
    _shadowFilter.forbidWebgl = forbidWebgl;
    filters.push(_shadowFilter);
  }
  if (reflection) {
    var reflectionFilter = new ReflectionFilter$1(reflection);
    reflectionFilter.forbidWebgl = forbidWebgl;
    filters.push(reflectionFilter);
  }
  return filters;
}

var _ButtStrokeDash;
var StrokeType;
(function (StrokeType) {
  /**
   * 实线
   */
  StrokeType["SOLID"] = "solid";
  /**
   * 虚线：点线
   */
  StrokeType["SYS_DOT"] = "sysDot";
  /**
   * 虚线：短划1
   */
  StrokeType["SYS_DASH"] = "sysDash";
  /**
   * 虚线：短划2
   */
  StrokeType["DASH"] = "dash";
  /**
   * 虚线：短划2+点
   */
  StrokeType["DASH_DOT"] = "dashDot";
  /**
   * 虚线：长划
   */
  StrokeType["LG_DASH"] = "lgDash";
  /**
   * 虚线：长划+点
   */
  StrokeType["LG_DASH_DOT"] = "lgDashDot";
  /**
   * 虚线：长划+点x2
   */
  StrokeType["LG_DASH_DOT_DOT"] = "lgDashDotDot";
  StrokeType["DOT"] = "dot";
  StrokeType["SYS_DASH_DOT"] = "sysDashDot";
  StrokeType["SYS_DASH_DOT_DOT"] = "sysDashDotDot";
})(StrokeType || (StrokeType = {}));
var StrokeDash = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, StrokeType.SOLID, ''), StrokeType.SYS_DOT, '0 2'), StrokeType.SYS_DASH, '2 2'), StrokeType.DASH, '3 4'), StrokeType.DASH_DOT, '3 4 0 4'), StrokeType.LG_DASH, '6 4'), StrokeType.LG_DASH_DOT, '6 4 0 4'), StrokeType.LG_DASH_DOT_DOT, '6 4 0 4 0 4'), StrokeType.DOT, '0 4');
var ButtStrokeDash = (_ButtStrokeDash = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ButtStrokeDash, StrokeType.SOLID, ''), StrokeType.SYS_DOT, '1 1'), StrokeType.SYS_DASH, '3 1'), StrokeType.DASH, '4 3'), StrokeType.DASH_DOT, '4 3 1 3'), StrokeType.LG_DASH, '7 3'), StrokeType.LG_DASH_DOT, '7 3 1 3'), StrokeType.LG_DASH_DOT_DOT, '7 3 1 3 1 3'), StrokeType.DOT, '1 3'), StrokeType.SYS_DASH_DOT, '3 1 1 1'), _defineProperty(_ButtStrokeDash, StrokeType.SYS_DASH_DOT_DOT, '3 1 1 1 1 1'));
// 边框的复合类型
var CompoundType;
(function (CompoundType) {
  // 单线
  CompoundType["SINGLE"] = "sng";
  // 双线
  CompoundType["DOUBLE"] = "dbl";
  // 由粗到细
  CompoundType["THICKTHIN"] = "thickThin";
  // 由细到粗
  CompoundType["THINTHICK"] = "thinThick";
  // 三线
  CompoundType["TRIPLE"] = "tri";
})(CompoundType || (CompoundType = {}));

var MIN_STROKE_WIDTH = 0.75;

var Stroke = /*#__PURE__*/function () {
  function Stroke(stroke, path, frame) {
    _classCallCheck(this, Stroke);
    this.isSolidLine = function (lineDash) {
      return Array.isArray(lineDash) && lineDash.length === 1 && lineDash[0] === '0';
    };
    this.stroke = stroke;
    this.path = path;
    this.frame = frame;
  }
  return _createClass(Stroke, [{
    key: "strokeWidth",
    get: function get() {
      var _this$stroke$lineWidt = this.stroke.lineWidth,
        lineWidth = _this$stroke$lineWidt === void 0 ? 1 : _this$stroke$lineWidt;
      var _this$stroke$minStrok = this.stroke.minStrokeWidth,
        minStrokeWidth = _this$stroke$minStrok === void 0 ? MIN_STROKE_WIDTH : _this$stroke$minStrok;
      var _this$path = this.path,
        _this$path$scaleX = _this$path.scaleX,
        scaleX = _this$path$scaleX === void 0 ? 1 : _this$path$scaleX,
        isLineEndPath = _this$path.isLineEndPath,
        notStroke = _this$path.notStroke;
      lineWidth = isLineEndPath && notStroke ? 0 : Math.max(lineWidth, minStrokeWidth);
      return lineWidth * (1 / scaleX);
    }
  }, {
    key: "hitStrokeWidth",
    get: function get() {
      var _this$stroke = this.stroke,
        _this$stroke$lineWidt2 = _this$stroke.lineWidth,
        lineWidth = _this$stroke$lineWidt2 === void 0 ? 1 : _this$stroke$lineWidt2,
        hitStrokeWidth = _this$stroke.hitStrokeWidth;
      if (hitStrokeWidth) {
        var _this$path2 = this.path,
          isLineEndPath = _this$path2.isLineEndPath,
          notStroke = _this$path2.notStroke,
          _this$path2$scaleX = _this$path2.scaleX,
          scaleX = _this$path2$scaleX === void 0 ? 1 : _this$path2$scaleX;
        if (isLineEndPath && notStroke) {
          return (hitStrokeWidth - lineWidth) * (1 / scaleX);
        }
        return hitStrokeWidth * (1 / scaleX);
      }
      return lineWidth;
    }
  }, {
    key: "lineCap",
    get: function get() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.path) === null || _a === void 0 ? void 0 : _a.lineCap) !== null && _b !== void 0 ? _b : this.stroke.lineCap) !== null && _c !== void 0 ? _c : LineCap.Butt;
    }
  }, {
    key: "lineJoin",
    get: function get() {
      var _a;
      return (_a = this.stroke.lineJoin) !== null && _a !== void 0 ? _a : LineJoin.Miter;
    }
  }, {
    key: "lineDash",
    get: function get() {
      var _this = this;
      var _a, _b, _c;
      var type = (_b = this.path.isLineEndPath ? StrokeType.SOLID : (_a = this.stroke) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : StrokeType.SOLID;
      if (type === StrokeType.SOLID) {
        return [];
      }
      var dashStr = '';
      if (this.lineCap === LineCap.Butt) {
        dashStr = ButtStrokeDash[type];
      } else {
        dashStr = StrokeDash[type];
      }
      if (typeof dashStr === 'undefined') {
        // 映射后没找到对应的类型，默认显示为实线
        dashStr = '';
      }
      var dashArray = (_c = dashStr === null || dashStr === void 0 ? void 0 : dashStr.split(' ')) === null || _c === void 0 ? void 0 : _c.map(function (item) {
        return parseInt(item, 10) * _this.realStrokeWidth;
      });
      if (this.isSolidLine(dashArray)) {
        return [];
      }
      return dashArray;
    }
  }, {
    key: "strokeFill",
    get: function get() {
      var _a;
      var _this$path3 = this.path,
        _this$path3$scaleX = _this$path3.scaleX,
        scaleX = _this$path3$scaleX === void 0 ? 1 : _this$path3$scaleX,
        _this$path3$scaleY = _this$path3.scaleY,
        scaleY = _this$path3$scaleY === void 0 ? 1 : _this$path3$scaleY;
      var fillMode = this.path.notStroke ? FillMode.NONE : FillMode.NORMAL;
      if (this.stroke.fillStyle.gradFill) {
        return GradFill.getGradFill(this.stroke.fillStyle.gradFill, {
          frame: Object.assign(Object.assign({}, this.frame), {
            width: this.frame.width || this.strokeWidth,
            height: this.frame.height || this.strokeWidth
          }),
          fillMode: fillMode,
          scaleX: scaleX,
          scaleY: scaleY,
          isStroke: true,
          textConfig: this.stroke.textConfig ? Object.assign(Object.assign({}, this.stroke.textConfig), {
            strokeWidth: this.strokeWidth
          }) : undefined
        });
      }
      var color = getRenderColor(generateColorWithFillMode((_a = this.stroke.fillStyle.solidFill) === null || _a === void 0 ? void 0 : _a.color, fillMode));
      if (color) {
        return new ColorFill(color);
      }
      return Fill.None;
    }
  }, {
    key: "realStrokeWidth",
    get: function get() {
      var width = this.strokeWidth;
      if (this.path.isCompoundPath) {
        width /= this.path.widthPercent || 1;
      }
      return width;
    }
  }]);
}();

export { ButtStrokeDash, CompoundType, DefaultDisplayOptions, DisplayRule, DisplayScene, FillMode, GradFill, GradientType$1 as GradientType, ImageFilter, LruCache, PatternFill, RectGradientFill, ShapeGradientFill, Stroke, StrokeDash, StrokeType, generateEffectFilters, imageCache, setFillStyle };
//# sourceMappingURL=index.esm.js.map
